var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomepage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.9913 0 0 1.9913 497.825 497.825)",
    id: 268268
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -182.905 118.14)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-67.095, -368.14)",
    d: "M 53.73 362.51 l 13.12 -0.27 l 6.66 -0.12 c 2.23 0 4.47 0 6.7 -0.05 h 0.44 v 0.44 l 0.06 11.19 v 0.51 h -0.5 L 67 374.14 c -4.42 0 -8.83 -0.11 -13.24 -0.16 h -0.28 v -0.27 c 0 -1.89 0.09 -3.78 0.13 -5.65 Z m 0 0 l 0.14 5.66 c 0 1.86 0.11 3.7 0.13 5.53 l -0.27 -0.27 c 4.41 -0.05 8.82 -0.16 13.24 -0.16 l 13.24 -0.06 l -0.5 0.49 l 0.05 -11.19 l 0.45 0.45 c -2.18 0 -4.36 0 -6.55 0 l -6.58 -0.12 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -168.15 104.03)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-81.85, -354.03)",
    d: "M 68.5 348.4 l 13.12 -0.27 l 6.66 -0.12 c 2.23 0 4.47 0 6.7 -0.05 h 0.44 v 0.45 l 0.06 11.18 v 0.51 H 95 L 81.74 360 c -4.41 0 -8.83 -0.11 -13.24 -0.16 h -0.28 v -0.27 c 0 -1.89 0.08 -3.78 0.13 -5.65 Z m 0 0 l 0.14 5.66 c 0 1.86 0.11 3.7 0.13 5.53 l -0.27 -0.27 c 4.41 -0.05 8.83 -0.16 13.24 -0.16 L 95 359.1 l -0.5 0.49 l 0 -11.18 l 0.45 0.44 c -2.18 0 -4.36 0 -6.55 -0.05 l -6.58 -0.12 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -197.67 104.03)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-52.33, -354.03)",
    d: "M 39 348.4 l 13.12 -0.27 l 6.66 -0.12 c 2.23 0 4.46 0 6.7 -0.05 h 0.44 v 0.45 l 0.06 11.18 v 0.51 h -0.5 L 52.2 360 c -4.42 0 -8.83 -0.11 -13.24 -0.16 h -0.28 v -0.27 c 0 -1.89 0.09 -3.78 0.13 -5.65 Z m 0 0 l 0.14 5.66 c 0 1.86 0.11 3.7 0.13 5.53 l -0.27 -0.27 c 4.41 -0.05 8.82 -0.16 13.24 -0.16 l 13.24 -0.06 l -0.5 0.49 l 0 -11.18 l 0.45 0.44 c -2.19 0 -4.36 0 -6.55 -0.05 l -6.58 -0.12 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 182.905 -211)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-432.905, -39)",
    d: "M 446.27 44.62 l -13.12 0.28 l -6.66 0.11 c -2.23 0.05 -4.47 0 -6.7 0.06 h -0.44 v -0.45 l -0.06 -11.19 v -0.5 h 0.5 L 433 33 c 4.42 0 8.83 0.12 13.24 0.17 h 0.28 v 0.27 c 0 1.9 -0.09 3.79 -0.13 5.65 Z m 0 0 L 446.13 39 c 0 -1.87 -0.11 -3.71 -0.13 -5.54 l 0.27 0.27 c -4.41 0 -8.82 0.16 -13.24 0.17 l -13.24 0.06 l 0.5 -0.5 l -0.05 11.19 l -0.45 -0.45 c 2.18 0 4.36 0 6.55 0.06 l 6.58 0.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 197.69 -196.915)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-447.69, -53.085)",
    d: "M 461 58.73 L 447.92 59 l -6.66 0.11 c -2.23 0.05 -4.46 0 -6.7 0.06 h -0.44 v -0.45 l -0.06 -11.19 V 47 h 0.5 l 13.24 0.06 c 4.42 0 8.83 0.12 13.24 0.17 h 0.28 v 0.27 c 0 1.9 -0.09 3.79 -0.13 5.65 Z m 0 0 l -0.14 -5.65 c 0 -1.87 -0.11 -3.71 -0.13 -5.54 l 0.27 0.27 c -4.41 0 -8.82 0.16 -13.24 0.17 L 434.56 48 l 0.5 -0.5 L 435 58.73 l -0.45 -0.45 c 2.19 0 4.36 0 6.55 0.06 l 6.58 0.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -197.89 -211.01)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-52.11, -38.99)",
    d: "M 65.44 44.63 l -13.13 0.28 L 45.65 45 c -2.23 0 -4.46 0 -6.69 0.06 h -0.45 v -0.45 l 0 -11.19 v -0.5 H 39 L 52.2 33 c 4.41 0 8.82 0.11 13.24 0.16 h 0.27 v 0.27 c 0 1.9 -0.09 3.79 -0.13 5.66 Z m 0 0 L 65.29 39 c 0 -1.86 -0.11 -3.71 -0.13 -5.54 l 0.28 0.28 c -4.42 0.05 -8.83 0.15 -13.24 0.16 L 39 33.94 l 0.49 -0.5 L 39.4 44.63 L 39 44.19 c 2.18 0 4.35 0 6.54 0.05 l 6.58 0.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 47.735 122.07)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-297.735, -372.07)",
    d: "M 284.38 366.45 l 13.13 -0.28 l 6.66 -0.11 c 2.22 -0.05 4.46 0 6.69 -0.06 h 0.45 v 0.45 l 0.05 11.19 v 0.5 h -0.5 l -13.24 -0.06 c -4.41 0 -8.83 -0.12 -13.24 -0.17 h -0.27 v -0.27 c 0 -1.9 0.08 -3.79 0.13 -5.65 Z m 0 0 l 0.14 5.65 c 0.05 1.87 0.12 3.71 0.13 5.54 l -0.27 -0.27 c 4.41 -0.05 8.83 -0.16 13.24 -0.17 l 13.24 -0.06 l -0.5 0.5 l 0.06 -11.19 l 0.44 0.45 c -2.18 0 -4.36 0 -6.54 -0.06 l -6.58 -0.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 197.895 67.09)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-447.895, -317.09)",
    d: "M 434.56 311.47 l 13.13 -0.28 l 6.66 -0.11 c 2.23 -0.05 4.46 0 6.69 -0.06 h 0.45 v 0.45 l 0.05 11.19 v 0.5 H 461 l -13.24 -0.06 c -4.41 0 -8.82 -0.12 -13.24 -0.17 h -0.27 v -0.27 c 0 -1.9 0.09 -3.79 0.13 -5.65 Z m 0 0 l 0.15 5.65 c 0 1.87 0.11 3.71 0.13 5.54 l -0.28 -0.27 c 4.42 -0.06 8.83 -0.16 13.24 -0.17 l 13.24 -0.06 l -0.49 0.5 l 0.05 -11.19 l 0.44 0.44 c -2.18 0 -4.35 0 -6.54 -0.05 l -6.58 -0.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 62.505 107.96)",
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-312.505, -357.96)",
    d: "M 299.15 352.34 l 13.13 -0.28 l 6.66 -0.11 c 2.22 -0.05 4.46 0 6.69 -0.06 h 0.45 v 0.45 l 0.05 11.19 v 0.5 h -0.51 L 312.39 364 c -4.41 0 -8.82 -0.12 -13.24 -0.17 h -0.27 v -0.27 c 0 -1.9 0.09 -3.79 0.13 -5.65 Z m 0 0 l 0.14 5.65 c 0 1.87 0.12 3.71 0.14 5.54 l -0.28 -0.27 c 4.42 -0.05 8.83 -0.16 13.24 -0.17 l 13.24 -0.06 l -0.5 0.5 l 0.06 -11.19 l 0.44 0.45 c -2.18 0 -4.35 0 -6.54 -0.06 l -6.58 -0.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 207.66)",
    id: "freepik--Shadow--inject-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    rx: 163.62,
    ry: 14.42
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -37.475)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-250, -212.525)",
    d: "M 66.34 69.65 V 355.4 H 433.66 V 69.65 Z M 426.26 348.41 H 73.74 V 76.64 H 426.26 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -37.475)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -176.26,
    y: -135.885,
    rx: 0,
    ry: 0,
    width: 352.52,
    height: 271.77
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -100.63 -101.96)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "75.63,-71.4 -75.63,71.4 -75.63,26.37 27.93,-71.4 75.63,-71.4 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 84.435 11.7)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "91.825,-86.71 91.825,-41.67 -44.125,86.71 -91.825,86.71 91.825,-86.71 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 35.775 -34.225)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "140.485,-132.635 140.485,-110.115 -116.625,132.635 -140.485,132.635 140.485,-132.635 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 158.225 81.38)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "18.035,-17.03 18.035,5.49 5.815,17.03 -18.035,17.03 18.035,-17.03 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -155.625 -153.87)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "20.635,-19.49 -20.635,19.49 -20.635,-3.05 -3.215,-19.49 20.635,-19.49 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -66.48 -69.715)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "109.78,-103.645 -109.78,103.645 -109.78,98.035 103.81,-103.645 109.78,-103.645 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 11.71 -37.475)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "146.9,-135.885 -140.95,135.885 -146.9,135.885 140.93,-135.885 146.9,-135.885 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 143.51 67.49)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "32.75,-30.92 32.75,-25.3 -26.78,30.92 -32.75,30.92 32.75,-30.92 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -137.475 -136.735)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    points: "38.785,-36.625 -38.785,36.625 -38.785,30.985 32.845,-36.625 38.785,-36.625 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -58.38 -37.475)",
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.7,
    y: -142.875,
    rx: 0,
    ry: 0,
    width: 7.4,
    height: 285.75
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -191.8)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-250, -58.2)",
    d: "M 447.24 76.15 H 52.76 c 23.61 -19.9 28.37 -35.9 28.37 -35.9 H 418.85 S 423.61 56.25 447.24 76.15 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -140.965 -191.85)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-109.035, -58.15)",
    d: "M 134.56 40.25 a 46.24 46.24 0 0 1 -2 9.45 c -0.47 1.55 -1.19 3.08 -1.8 4.61 c -0.33 0.77 -0.78 1.52 -1.16 2.28 a 21.11 21.11 0 0 1 -1.26 2.26 a 59.21 59.21 0 0 1 -6.45 8.83 c -1.28 1.44 -2.6 2.87 -4 4.27 s -3 2.77 -4.67 4.1 l -0.06 0.06 v 0 H 83.51 c 1.86 -1.29 3.52 -2.63 5.14 -4 s 3.27 -2.78 4.73 -4.22 a 71.36 71.36 0 0 0 7.84 -8.83 a 44.65 44.65 0 0 0 5.42 -9.24 a 27.53 27.53 0 0 0 2.2 -9.63 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -85.99 -191.825)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-164.01, -58.175)",
    d: "M 183.84 40.25 c -0.2 1.52 -0.33 3.12 -0.47 4.62 l -0.56 4.53 c -0.53 3 -0.89 6 -1.68 9 c -0.35 1.5 -0.78 3 -1.18 4.49 s -0.94 3 -1.51 4.45 a 36.47 36.47 0 0 1 -4.63 8.73 v 0.07 H 144.18 a 37 37 0 0 0 4.12 -4.08 a 40.87 40.87 0 0 0 3.36 -4.34 a 46.83 46.83 0 0 0 4.76 -9 a 46.7 46.7 0 0 0 1.48 -4.57 c 0.2 -0.77 0.44 -1.53 0.58 -2.3 l 0.38 -2.31 a 18 18 0 0 0 0.27 -2.31 l 0.16 -2.31 c 0 -1.54 0 -3.18 -0.14 -4.71 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -29.305 -191.84)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-220.695, -58.16)",
    d: "M 236.55 40.25 c -0.27 1.67 -0.42 3.43 -0.64 5.1 l -0.45 5 c -0.27 3.33 -0.39 6.67 -0.61 10 c -0.07 3.34 -0.24 6.68 -0.24 10 c 0 1.93 0 3.86 0 5.79 H 204.84 a 41.22 41.22 0 0 0 1.42 -4.42 a 41.46 41.46 0 0 0 1.07 -4.47 a 80.45 80.45 0 0 0 1.26 -9 a 81.58 81.58 0 0 0 0.31 -9 c 0 -1.5 -0.09 -3 -0.18 -4.49 s -0.25 -3.08 -0.45 -4.58 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 29.265 -191.76)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-279.265, -58.24)",
    d: "M 265.35 76.15 c 0 -1.93 0 -3.86 0 -5.79 c 0 -3.33 -0.17 -6.67 -0.24 -10 s -0.34 -6.67 -0.61 -10 l -0.45 -5 c -0.22 -1.67 -0.37 -3.43 -0.64 -5.1 h 28.28 c -0.2 1.5 -0.32 3.09 -0.45 4.58 s -0.16 3 -0.18 4.49 a 81.58 81.58 0 0 0 0.31 9 a 80.45 80.45 0 0 0 1.26 9 a 41.46 41.46 0 0 0 1.07 4.47 a 41.22 41.22 0 0 0 1.42 4.42 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 86.02 -191.705)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-336.02, -58.295)",
    d: "M 326.2 76.15 v 0 l 0 0 a 37.11 37.11 0 0 1 -4.61 -8.73 c -0.57 -1.47 -1.06 -3 -1.51 -4.45 s -0.83 -3 -1.18 -4.49 c -0.79 -3 -1.15 -6 -1.68 -9 l -0.56 -4.53 c -0.14 -1.5 -0.27 -3.1 -0.47 -4.62 h 24.69 c -0.09 1.53 -0.16 3.17 -0.14 4.71 l 0.16 2.31 a 18 18 0 0 0 0.27 2.31 l 0.38 2.31 c 0.14 0.77 0.38 1.53 0.58 2.3 a 46.7 46.7 0 0 0 1.48 4.57 a 46.83 46.83 0 0 0 4.76 9 a 40.87 40.87 0 0 0 3.36 4.34 a 37 37 0 0 0 4.12 4.08 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 140.985 -191.745)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-390.985, -58.255)",
    d: "M 386.88 76.15 v 0 l -0.06 -0.06 c -1.66 -1.33 -3.21 -2.7 -4.67 -4.1 s -2.73 -2.83 -4 -4.27 a 59.21 59.21 0 0 1 -6.45 -8.83 a 21.11 21.11 0 0 1 -1.26 -2.26 c -0.38 -0.76 -0.83 -1.51 -1.16 -2.28 c -0.61 -1.53 -1.33 -3.06 -1.8 -4.61 a 46.24 46.24 0 0 1 -2 -9.45 h 25.72 a 27.53 27.53 0 0 0 2.2 9.63 a 44.65 44.65 0 0 0 5.42 9.24 A 71.36 71.36 0 0 0 406.62 68 c 1.46 1.44 3.05 2.84 4.73 4.22 s 3.28 2.69 5.14 4 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -168.005)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -197.23,
    y: -5.845,
    rx: 0,
    ry: 0,
    width: 394.46,
    height: 11.69
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -151.74 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "15.17,5.84 -15.17,5.84 -14.72,-5.84 14.72,-5.84 15.17,5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -91.05 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "15.17,5.84 -15.17,5.84 -14.72,-5.84 14.72,-5.84 15.17,5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.36 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "15.17,5.84 -15.17,5.84 -14.72,-5.84 14.72,-5.84 15.17,5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.325 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "15.175,5.84 -15.175,5.84 -14.715,-5.84 14.725,-5.84 15.175,5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 91.015 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-341.015, -81.99)",
    d: "M 355.73 76.15 H 326.29 l -0.45 11.68 h 30.35 Z m 0.09 9.89 h 0.05 l 0 0.1 s 0 0 0 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 105.845 -163.95)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-355.845, -86.05)",
    d: "M 355.87 86 l 0 0.1 s 0 0 0 0 l -0.05 -0.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 151.72 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-401.72, -81.99)",
    d: "M 416.42 76.15 H 387 l -0.45 11.68 h 30.34 Z m 0.07 9.89 h 0.08 l 0.05 0.11 a 0.12 0.12 0 0 1 -0.05 -0.05 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 166.555 -163.945)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-416.555, -86.055)",
    d: "M 416.57 86 l 0.05 0.11 a 0.12 0.12 0 0 1 -0.05 -0.05 l -0.08 -0.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -154.19 -191.765)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-95.81, -58.235)",
    d: "M 108.84 40.25 a 27.53 27.53 0 0 1 -2.2 9.63 a 44.65 44.65 0 0 1 -5.42 9.24 A 71.36 71.36 0 0 1 93.38 68 c -1.46 1.44 -3 2.84 -4.73 4.22 s -3.28 2.69 -5.14 4 l -0.08 0 l -0.05 0 l 0.05 -0.09 h -0.65 v 0 l 0.06 -0.06 a 106.71 106.71 0 0 0 9.24 -8.41 a 94.21 94.21 0 0 0 7.64 -8.78 a 58.87 58.87 0 0 0 5.76 -9.11 l 1.1 -2.32 c 0.35 -0.77 0.56 -1.57 0.89 -2.35 A 41.92 41.92 0 0 0 108.84 40.25 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -126.0916 -191.78)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-123.9084, -58.22)",
    d: "M 133.71 49.78 a 34.88 34.88 0 0 1 -3.87 9.28 A 48.38 48.38 0 0 1 123.18 68 a 57.51 57.51 0 0 1 -9.34 8.18 a 0.09 0.09 0 0 1 0 0 l 0 0 l 0 -0.06 h -0.67 v 0 l 0.06 -0.06 c 1.66 -1.33 3.21 -2.7 4.67 -4.1 s 2.73 -2.83 4 -4.27 a 59.21 59.21 0 0 0 6.45 -8.83 a 21.11 21.11 0 0 0 1.26 -2.26 c 0.38 -0.76 0.83 -1.51 1.16 -2.28 c 0.61 -1.53 1.33 -3.06 1.8 -4.61 a 46.24 46.24 0 0 0 2 -9.45 A 29.6 29.6 0 0 1 133.71 49.78 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.3011 -191.815)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-235.6989, -58.185)",
    d: "M 236.75 50.36 c 0 3.34 -0.17 6.67 -0.24 10 s -0.34 6.67 -0.63 10 c -0.16 1.92 -0.33 3.85 -0.54 5.77 h -0.69 c 0 -1.93 -0.05 -3.86 0 -5.79 c 0 -3.33 0.17 -6.67 0.24 -10 c 0.22 -3.33 0.34 -6.67 0.61 -10 l 0.45 -5 c 0.22 -1.67 0.37 -3.43 0.64 -5.1 c 0.11 1.67 0.11 3.44 0.18 5.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.34 -191.79)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-264.34, -58.21)",
    d: "M 265.39 70.36 c 0 1.93 0 3.86 0 5.79 h -0.69 c -0.21 -1.92 -0.38 -3.85 -0.54 -5.77 c -0.29 -3.34 -0.41 -6.67 -0.63 -10 s -0.22 -6.67 -0.24 -10 l 0 -5 c 0.07 -1.67 0.07 -3.44 0.18 -5.11 c 0.27 1.67 0.42 3.43 0.64 5.1 l 0.45 5 c 0.27 3.33 0.39 6.67 0.61 10 S 265.39 67 265.39 70.36 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -43.477 -191.74)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-206.523, -58.26)",
    d: "M 208.59 58.3 a 80.45 80.45 0 0 1 -1.26 9 a 41.46 41.46 0 0 1 -1.07 4.47 a 41.22 41.22 0 0 1 -1.42 4.42 h -0.71 v 0 c 0.8 -3 1.25 -5.93 1.75 -8.91 s 0.76 -6 1.12 -8.94 s 0.47 -6 0.73 -8.94 l 0.54 -9.07 c 0.2 1.5 0.32 3.09 0.45 4.58 s 0.16 3 0.18 4.49 A 81.58 81.58 0 0 1 208.59 58.3 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -71.045 -191.785)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-178.955, -58.215)",
    d: "M 184.09 44.88 c 0 1.52 -0.06 3 -0.11 4.55 a 57.52 57.52 0 0 1 -1.26 9.07 a 47.17 47.17 0 0 1 -2.88 9 a 34.72 34.72 0 0 1 -2.25 4.42 a 24 24 0 0 1 -3.09 4.24 s 0 0 0 0 h 0 l 0 0 h -0.68 v -0.07 a 36.47 36.47 0 0 0 4.63 -8.73 c 0.57 -1.47 1.06 -3 1.51 -4.45 s 0.83 -3 1.18 -4.49 c 0.79 -3 1.15 -6 1.68 -9 l 0.56 -4.53 c 0.14 -1.5 0.27 -3.1 0.47 -4.62 C 184 41.77 184 43.37 184.09 44.88 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -98.6233 -191.725)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-151.3767, -58.275)",
    d: "M 159.29 45 l -0.16 2.31 a 18 18 0 0 1 -0.27 2.31 l -0.38 2.31 c -0.14 0.77 -0.38 1.53 -0.58 2.3 a 46.7 46.7 0 0 1 -1.48 4.57 a 46.83 46.83 0 0 1 -4.76 9 a 40.87 40.87 0 0 1 -3.36 4.34 a 37 37 0 0 1 -4.12 4.08 s 0 0 -0.05 0 l 0 0 l 0 -0.08 h -0.67 v 0 l 0 0 a 46.56 46.56 0 0 0 6.78 -8.55 a 59.6 59.6 0 0 0 4.58 -8.9 a 63 63 0 0 0 2.84 -9.08 c 0.43 -1.52 0.54 -3.05 0.86 -4.58 s 0.35 -3.17 0.6 -4.7 C 159.24 41.78 159.31 43.42 159.29 45 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 154.19 -191.72)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-404.19, -58.28)",
    d: "M 417.22 76.15 h -0.65 l 0.05 0.09 l -0.05 0 l -0.08 0 c -1.86 -1.29 -3.52 -2.63 -5.14 -4 s -3.27 -2.78 -4.73 -4.22 a 71.36 71.36 0 0 1 -7.84 -8.83 a 44.65 44.65 0 0 1 -5.42 -9.24 a 27.53 27.53 0 0 1 -2.2 -9.63 a 41.92 41.92 0 0 0 1.37 4.83 c 0.33 0.78 0.54 1.58 0.89 2.35 l 1.1 2.32 a 58.87 58.87 0 0 0 5.76 9.11 a 94.21 94.21 0 0 0 7.64 8.78 a 106.71 106.71 0 0 0 9.24 8.41 l 0.06 0.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 126.1202 -191.755)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-376.1202, -58.245)",
    d: "M 386.88 76.15 h -0.67 l 0 0.06 l 0 0 a 0.09 0.09 0 0 1 0 0 A 57.51 57.51 0 0 1 376.82 68 a 48.38 48.38 0 0 1 -6.66 -8.91 a 34.88 34.88 0 0 1 -3.87 -9.28 a 29.6 29.6 0 0 1 -0.85 -9.53 a 46.24 46.24 0 0 0 2 9.45 c 0.47 1.55 1.19 3.08 1.8 4.61 c 0.33 0.77 0.78 1.52 1.16 2.28 a 21.11 21.11 0 0 0 1.26 2.26 a 59.21 59.21 0 0 0 6.45 8.83 c 1.28 1.44 2.6 2.87 4 4.27 s 3 2.77 4.67 4.1 l 0.06 0.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 43.4762 -191.87)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-293.4762, -58.13)",
    d: "M 295.87 76.11 v 0 h -0.71 a 41.22 41.22 0 0 1 -1.42 -4.42 a 41.46 41.46 0 0 1 -1.07 -4.47 a 80.45 80.45 0 0 1 -1.26 -9 a 81.58 81.58 0 0 1 -0.31 -9 c 0 -1.5 0.09 -3 0.18 -4.49 s 0.25 -3.08 0.45 -4.58 l 0.54 9.07 c 0.26 3 0.38 6 0.73 8.94 s 0.61 6 1.12 8.94 S 295.07 73.16 295.87 76.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 71.045 -191.8)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-321.045, -58.2)",
    d: "M 326.2 76.15 h -0.68 l 0 0 h 0 s 0 0 0 0 a 24 24 0 0 1 -3.09 -4.24 a 34.72 34.72 0 0 1 -2.25 -4.42 a 47.17 47.17 0 0 1 -2.88 -9 A 57.52 57.52 0 0 1 316 49.43 c 0 -1.52 -0.11 -3 -0.11 -4.55 s 0.13 -3.11 0.25 -4.63 c 0.2 1.52 0.33 3.12 0.47 4.62 l 0.56 4.53 c 0.53 3 0.89 6 1.68 9 c 0.35 1.5 0.78 3 1.18 4.49 s 0.94 3 1.51 4.45 a 37.11 37.11 0 0 0 4.61 8.73 l 0 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 98.625 -191.74)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-348.625, -58.26)",
    d: "M 356.54 76.15 h -0.67 l 0 0.08 l 0 0 s 0 0 -0.05 0 a 37 37 0 0 1 -4.12 -4.08 a 40.87 40.87 0 0 1 -3.36 -4.34 a 46.83 46.83 0 0 1 -4.76 -9 a 46.7 46.7 0 0 1 -1.48 -4.57 c -0.2 -0.77 -0.44 -1.53 -0.58 -2.3 l -0.38 -2.31 a 18 18 0 0 1 -0.27 -2.31 L 340.71 45 c 0 -1.54 0.05 -3.18 0.14 -4.71 c 0.25 1.53 0.34 3.17 0.6 4.7 s 0.43 3.06 0.86 4.58 a 63 63 0 0 0 2.84 9.08 a 59.6 59.6 0 0 0 4.58 8.9 a 46.56 46.56 0 0 0 6.78 8.55 l 0 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 75.52 -163.96)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-325.52, -86.04)",
    d: "M 325.52 86 l 0 0.08 s 0 0 0 -0.05 l 0 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 105.885 -163.89)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-355.885, -86.11)",
    d: "M 355.91 86.14 s 0 0 0 0 l -0.05 -0.06 h 0.05 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 136.245 -163.945)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-386.245, -86.055)",
    d: "M 386.21 86 l 0.07 0.11 a 0.46 0.46 0 0 0 -0.07 -0.07 l 0 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 166.555 -163.905)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-416.555, -86.095)",
    d: "M 416.62 86.15 a 0.12 0.12 0 0 1 -0.05 -0.05 l -0.08 -0.06 h 0.08 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -166.91 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -136.57 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -106.22 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -75.88 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -45.535 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.455,-5.84 0.005,5.84 -0.455,-5.84 0.455,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -15.19 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.155 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.455,-5.84 -0.005,5.84 -0.455,-5.84 0.455,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 45.5 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 75.84 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 106.185 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.455,-5.84 0.005,5.84 -0.455,-5.84 0.455,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 136.53 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.45,-5.84 0,5.84 -0.45,-5.84 0.45,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 166.875 -168.01)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "0.455,-5.84 -0.005,5.84 -0.455,-5.84 0.455,-5.84 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -168.005)",
    id: "freepik--shop-roof--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    x: -197.23,
    y: -5.845,
    rx: 0,
    ry: 0,
    width: 394.46,
    height: 11.69
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.27 -116.66)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -38.86,
    y: -3.43,
    rx: 0,
    ry: 0,
    width: 77.72,
    height: 6.86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.27 -51.68)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -38.86,
    y: -3.43,
    rx: 0,
    ry: 0,
    width: 77.72,
    height: 6.86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.27 13.29)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -38.86,
    y: -3.43,
    rx: 0,
    ry: 0,
    width: 77.72,
    height: 6.86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.27 78.27)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -38.86,
    y: -3.43,
    rx: 0,
    ry: 0,
    width: 77.72,
    height: 6.86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.27 -51.67)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -38.86,
    y: -3.43,
    rx: 0,
    ry: 0,
    width: 77.72,
    height: 6.86
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.8548 -129.4259)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.1453, -120.5741)",
    d: "M 156.38 129.61 c -1.84 0.6 -54.26 0.75 -56.25 -0.52 c -0.76 -0.49 -1.47 -9.1 -0.69 -18 l 33.79 0.28 s 19.35 9.12 21.38 10.76 S 158.21 129 156.38 129.61 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.5942 -124.8713)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.4058, -125.1287)",
    d: "M 157.15 128.45 a 1.28 1.28 0 0 1 -0.77 1.16 c -1.83 0.6 -54.26 0.75 -56.26 -0.53 c -0.18 -0.11 -0.35 -0.69 -0.5 -1.62 h 44.32 a 9.08 9.08 0 0 1 2.47 -5.17 a 7.93 7.93 0 0 1 4.91 -2.09 a 29.05 29.05 0 0 1 3.28 1.89 a 9 9 0 0 1 2.57 5.37 A 4 4 0 0 1 157.15 128.45 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.785 -122.5684)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.215, -127.4316)",
    d: "M 155.64 127.51 c -8.78 -0.28 -44.24 -0.58 -52.94 -0.18 c -0.07 0 -0.07 0 0 0 c 8.7 0.47 44.16 0.47 52.94 0.27 C 155.83 127.65 155.83 127.51 155.64 127.51 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -102.3473 -126.4087)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-147.6527, -123.5913)",
    d: "M 151.25 120.19 A 7 7 0 0 0 146 122.3 a 6.86 6.86 0 0 0 -2 4.67 s 0.1 0.06 0.11 0 a 8.16 8.16 0 0 1 7.16 -6.67 C 151.32 120.29 151.32 120.19 151.25 120.19 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -118.809 -135.6656)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-131.191, -114.3344)",
    d: "M 136 112.24 c -3.52 -0.07 -7.6 1.14 -9.81 4 c -0.08 0.11 0.07 0.23 0.18 0.18 a 48.47 48.47 0 0 1 9.69 -3.75 A 0.22 0.22 0 0 0 136 112.24 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -116.1252 -134.5885)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-133.8747, -115.4116)",
    d: "M 138.69 113.32 c -3.52 -0.07 -7.61 1.14 -9.81 4 c -0.09 0.11 0.07 0.23 0.18 0.17 a 49.2 49.2 0 0 1 9.68 -3.74 A 0.22 0.22 0 0 0 138.69 113.32 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.4185 -133.5088)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-136.5815, -116.4912)",
    d: "M 141.39 114.4 c -3.51 -0.08 -7.6 1.14 -9.81 4 c -0.08 0.11 0.08 0.23 0.18 0.17 a 49.05 49.05 0 0 1 9.69 -3.74 A 0.22 0.22 0 0 0 141.39 114.4 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -110.716 -132.4356)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-139.284, -117.5644)",
    d: "M 144.1 115.47 c -3.52 -0.07 -7.6 1.14 -9.81 4 c -0.08 0.11 0.07 0.23 0.18 0.18 a 47.84 47.84 0 0 1 9.69 -3.74 A 0.23 0.23 0 0 0 144.1 115.47 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -145 -129.445)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-105, -120.555)",
    d: "M 105 117.49 c -4 0 -4 6.12 0 6.13 S 109 117.51 105 117.49 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.8417 -142.0059)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-136.1583, -107.9941)",
    d: "M 139.85 102.89 c -1.77 -1.49 -4 -0.07 -5.13 1.46 a 18.51 18.51 0 0 0 -3 7 c -0.08 0.35 -0.14 0.7 -0.19 1 c 0 0.16 0 0.31 0 0.45 s 0 0 0 0 a 0.23 0.23 0 0 1 0 0.12 c 0 0.12 0 0.23 0 0.35 a 0.11 0.11 0 0 0 0.12 0.11 a 0.44 0.44 0 0 0 0.35 0.34 a 0.34 0.34 0 0 0 0.27 -0.05 c 0.69 -0.47 1.42 -0.94 2.15 -1.41 l 0.39 -0.25 a 19.2 19.2 0 0 0 4.8 -4 C 140.65 106.62 141.52 104.29 139.85 102.89 Z m -4.37 7.44 l -1.77 1.23 c -0.51 0.35 -1 0.72 -1.52 1.09 l -0.18 0.13 a 1.24 1.24 0 0 1 -0.18 0.14 a 1.59 1.59 0 0 1 0.07 -0.2 s 0 0 0 0 c 0.16 -0.46 0.33 -0.92 0.49 -1.37 a 30.41 30.41 0 0 1 1.45 -3.6 a 19.27 19.27 0 0 1 1.29 -2.36 c 0.77 -1.16 4.25 -4.08 4.57 -0.25 C 139.89 107.24 136.93 109.28 135.48 110.33 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -124.3663 -138.4051)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-125.6336, -111.5948)",
    d: "M 132.21 113.11 a 0.09 0.09 0 0 0 0 -0.14 l -0.22 -0.19 s 0 -0.06 -0.08 -0.07 s 0 0 0 0 a 3.68 3.68 0 0 0 -0.37 -0.32 a 14.14 14.14 0 0 0 -1.44 -1.07 a 17.94 17.94 0 0 0 -6.36 -2.72 c -1.84 -0.38 -4.46 0.1 -4.75 2.4 a 1.85 1.85 0 0 0 0 0.23 c -0.11 2 2 3.07 3.73 3.34 a 17.46 17.46 0 0 0 5.44 -0.17 c 1.27 -0.2 2.54 -0.44 3.77 -0.63 h 0 A 0.43 0.43 0 0 0 132.21 113.11 Z m -5 0.39 c -1.78 0.21 -5.35 0.72 -6.65 -1 a 2.87 2.87 0 0 1 -0.65 -1.31 c -0.27 -1.78 3 -1.88 4.17 -1.61 a 19.24 19.24 0 0 1 2.56 0.86 c 0.62 0.25 1.23 0.52 1.83 0.82 c 1 0.48 2 1 3 1.53 a 0 0 0 0 1 0 0 a 0.87 0.87 0 0 1 0.19 0.1 l -0.22 0 a 4.23 4.23 0 0 0 -0.5 0.05 C 129.72 113.15 128.49 113.35 127.25 113.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.8548 0.2758)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.1453, -250.2758)",
    d: "M 156.38 259.31 c -1.84 0.6 -54.26 0.76 -56.25 -0.52 c -0.76 -0.48 -1.47 -9.09 -0.69 -18 l 33.79 0.28 s 19.35 9.12 21.38 10.75 S 158.21 258.71 156.38 259.31 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.785 7.1624)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.215, -257.1624)",
    d: "M 155.64 257.21 c -8.78 -0.28 -44.23 -0.57 -52.94 -0.18 c -0.07 0 -0.07 0.05 0 0.06 c 8.7 0.46 44.16 0.47 52.94 0.27 C 155.83 257.35 155.83 257.22 155.64 257.21 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -102.3481 3.3022)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-147.6519, -253.3023)",
    d: "M 151.25 249.89 A 7.08 7.08 0 0 0 146 252 a 6.85 6.85 0 0 0 -2 4.68 c 0 0.05 0.09 0.05 0.1 0 a 8.17 8.17 0 0 1 7.16 -6.68 C 151.32 250 151.32 249.9 151.25 249.89 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -118.8085 -5.9088)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-131.1915, -244.0912)",
    d: "M 136 242 c -3.52 -0.08 -7.6 1.14 -9.81 4 c -0.08 0.11 0.08 0.23 0.18 0.17 a 49.05 49.05 0 0 1 9.69 -3.74 A 0.22 0.22 0 0 0 136 242 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -116.105 -4.906)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-133.895, -245.094)",
    d: "M 138.69 243 c -3.52 -0.08 -7.61 1.13 -9.81 4 c -0.09 0.11 0.07 0.23 0.18 0.18 a 49.2 49.2 0 0 1 9.68 -3.74 A 0.22 0.22 0 0 0 138.69 243 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.3972 -3.8056)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-136.6028, -246.1944)",
    d: "M 141.39 244.1 c -3.51 -0.07 -7.6 1.14 -9.8 4 c -0.09 0.11 0.07 0.23 0.17 0.18 a 47.84 47.84 0 0 1 9.69 -3.74 A 0.22 0.22 0 0 0 141.39 244.1 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -110.7085 -2.7256)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-139.2915, -247.2744)",
    d: "M 144.1 245.18 c -3.52 -0.07 -7.6 1.14 -9.81 4 c -0.08 0.11 0.08 0.23 0.18 0.18 a 48.47 48.47 0 0 1 9.69 -3.75 A 0.22 0.22 0 0 0 144.1 245.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -145 1.77)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-105, -251.77)",
    d: "M 105 248.7 c -4 0 -4 6.12 0 6.14 S 109 248.72 105 248.7 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.8685 -12.2849)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-136.1316, -237.7151)",
    d: "M 139.85 232.59 c -1.77 -1.49 -4 -0.06 -5.13 1.46 a 18.63 18.63 0 0 0 -3 7 a 9.6 9.6 0 0 0 -0.18 1.05 l -0.06 0.44 s 0 0 0 0 v 0.12 c 0 0.13 0 0.25 0 0.37 a 0.09 0.09 0 0 0 0.12 0.09 a 0.44 0.44 0 0 0 0.35 0.34 a 0.34 0.34 0 0 0 0.27 -0.05 c 0.7 -0.47 1.42 -0.94 2.15 -1.41 l 0.38 -0.23 a 18.9 18.9 0 0 0 4.81 -4 C 140.65 236.32 141.52 234 139.85 232.59 Z M 135.48 240 l -1.77 1.24 l -1.49 1.07 a 1.75 1.75 0 0 0 -0.2 0.16 l -0.19 0.14 l 0.07 -0.21 v 0 c 0.16 -0.46 0.33 -0.9 0.48 -1.36 a 34.94 34.94 0 0 1 1.46 -3.61 a 20.71 20.71 0 0 1 1.29 -2.36 c 0.78 -1.15 4.25 -4.06 4.57 -0.23 C 139.89 236.94 136.93 239 135.48 240 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -124.3617 -8.6998)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-125.6382, -241.3002)",
    d: "M 132.22 242.83 a 0.12 0.12 0 0 0 0 -0.16 a 1 1 0 0 0 -0.21 -0.17 a 0.25 0.25 0 0 0 -0.09 -0.09 s 0 0 0 0 a 2 2 0 0 0 -0.36 -0.31 a 12.3 12.3 0 0 0 -1.43 -1.06 a 18.25 18.25 0 0 0 -6.37 -2.74 c -1.85 -0.37 -4.47 0.11 -4.76 2.4 a 1.93 1.93 0 0 0 0 0.24 c -0.1 2 2 3.06 3.73 3.34 a 17.59 17.59 0 0 0 5.46 -0.18 c 1.26 -0.2 2.52 -0.44 3.75 -0.63 h 0 A 0.43 0.43 0 0 0 132.22 242.83 Z m -5 0.37 c -1.78 0.22 -5.35 0.72 -6.65 -0.95 A 2.89 2.89 0 0 1 120 241 c -0.27 -1.79 3 -1.88 4.17 -1.61 a 20.71 20.71 0 0 1 2.56 0.84 c 0.64 0.25 1.25 0.53 1.86 0.84 c 1 0.48 2 1 3 1.51 h 0 l 0.19 0.1 l -0.2 0 a 4.57 4.57 0 0 0 -0.52 0.05 C 129.73 242.85 128.49 243.05 127.25 243.2 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.8558 62.1258)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.1443, -312.1258)",
    d: "M 156.38 325.66 c -1.84 0.6 -54.26 0.76 -56.25 -0.52 c -0.76 -0.48 -1.47 -18 -0.69 -27 l 33.79 0.28 s 0.23 9.05 0.64 9.25 c 3.37 1.59 18.93 9 20.74 10.45 C 156.63 319.78 158.21 325.06 156.38 325.66 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.785 73.5109)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.215, -323.5109)",
    d: "M 155.64 323.56 c -8.78 -0.28 -44.23 -0.57 -52.94 -0.18 c -0.07 0 -0.07 0.05 0 0.05 c 8.7 0.47 44.16 0.48 52.94 0.27 C 155.83 323.7 155.83 323.57 155.64 323.56 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -102.3692 69.6507)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-147.6308, -319.6507)",
    d: "M 151.25 316.24 a 7.08 7.08 0 0 0 -5.27 2.11 a 6.81 6.81 0 0 0 -2 4.67 c 0 0.06 0.09 0.06 0.1 0 a 8.16 8.16 0 0 1 7.16 -6.67 A 0.06 0.06 0 0 0 151.25 316.24 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.7948 51.3601)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.2051, -301.3601)",
    d: "M 134.46 301.74 c -3.24 -1.38 -7.48 -1.78 -10.59 0.06 c -0.12 0.07 0 0.24 0.1 0.23 a 48.68 48.68 0 0 1 10.38 0.13 A 0.22 0.22 0 0 0 134.46 301.74 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.4548 54.1601)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.5451, -304.1601)",
    d: "M 134.8 304.54 c -3.23 -1.38 -7.48 -1.78 -10.59 0.06 c -0.12 0.07 0 0.24 0.1 0.23 a 48 48 0 0 1 10.38 0.13 A 0.22 0.22 0 0 0 134.8 304.54 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.0947 56.9612)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.9053, -306.9612)",
    d: "M 135.14 307.33 c -3.23 -1.37 -7.47 -1.77 -10.59 0.06 c -0.12 0.07 0 0.24 0.1 0.23 a 48.78 48.78 0 0 1 10.39 0.14 A 0.22 0.22 0 0 0 135.14 307.33 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -143.5749 59.77)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-106.425, -309.77)",
    d: "M 106.43 298.59 c 0.15 1.87 0.23 3.73 0.29 5.59 s 0.07 3.73 0.08 5.59 s 0 3.73 -0.08 5.59 s -0.13 3.73 -0.29 5.59 c -0.16 -1.86 -0.23 -3.73 -0.29 -5.59 s -0.08 -3.73 -0.09 -5.59 s 0 -3.73 0.09 -5.59 S 106.27 300.46 106.43 298.59 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.8558 -74.9909)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.1443, -175.0091)",
    d: "M 156.38 194.81 c -1.84 0.6 -54.26 0.75 -56.25 -0.52 c -0.76 -0.48 -1.47 -30.6 -0.69 -39.53 l 33.79 0.28 s 0.23 21.61 0.64 21.8 c 3.37 1.6 18.93 9 20.74 10.46 C 156.63 188.93 158.21 194.21 156.38 194.81 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.8558 -74.9909)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-128.1443, -175.0091)",
    d: "M 156.38 194.81 c -1.84 0.6 -54.26 0.75 -56.25 -0.52 c -0.76 -0.48 -1.47 -30.6 -0.69 -39.53 l 33.79 0.28 s 0.23 21.61 0.64 21.8 c 3.37 1.6 18.93 9 20.74 10.46 C 156.63 188.93 158.21 194.21 156.38 194.81 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.785 -57.3391)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.215, -192.6609)",
    d: "M 155.64 192.71 c -8.78 -0.28 -44.23 -0.57 -52.94 -0.18 c -0.07 0 -0.07 0.05 0 0.05 c 8.7 0.47 44.16 0.48 52.94 0.27 C 155.83 192.85 155.83 192.71 155.64 192.71 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -102.3481 -61.2013)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-147.6519, -188.7987)",
    d: "M 151.25 185.39 A 7 7 0 0 0 146 187.5 a 6.81 6.81 0 0 0 -2 4.67 c 0 0.05 0.09 0.06 0.1 0 a 8.16 8.16 0 0 1 7.16 -6.67 C 151.32 185.49 151.32 185.39 151.25 185.39 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.873 -79.4136)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.1271, -170.5864)",
    d: "M 134.38 171.05 c -3.19 -1.47 -7.42 -2 -10.59 -0.25 c -0.12 0.07 0 0.24 0.09 0.23 a 48.1 48.1 0 0 1 10.38 0.44 A 0.22 0.22 0 0 0 134.38 171.05 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.6128 -76.6136)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.3872, -173.3864)",
    d: "M 134.64 173.85 c -3.19 -1.47 -7.42 -2 -10.59 -0.25 c -0.12 0.07 0 0.25 0.1 0.24 a 48.65 48.65 0 0 1 10.37 0.43 A 0.22 0.22 0 0 0 134.64 173.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.1128 -82.2236)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.8872, -167.7764)",
    d: "M 134.14 168.24 c -3.19 -1.47 -7.42 -2 -10.59 -0.25 c -0.12 0.07 0 0.24 0.1 0.24 a 48.65 48.65 0 0 1 10.37 0.43 A 0.22 0.22 0 0 0 134.14 168.24 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.363 -85.0236)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.6371, -164.9764)",
    d: "M 133.89 165.44 c -3.19 -1.47 -7.42 -2 -10.59 -0.25 c -0.12 0.07 0 0.24 0.09 0.23 a 48.1 48.1 0 0 1 10.38 0.44 A 0.22 0.22 0 0 0 133.89 165.44 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.613 -87.8336)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.3871, -162.1664)",
    d: "M 133.64 162.63 c -3.19 -1.47 -7.42 -2 -10.59 -0.25 c -0.12 0.07 0 0.24 0.09 0.24 a 48.74 48.74 0 0 1 10.38 0.43 A 0.22 0.22 0 0 0 133.64 162.63 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -121.8719 -90.6391)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-128.1281, -159.361)",
    d: "M 133.39 159.82 c -3.2 -1.47 -7.42 -2 -10.59 -0.24 c -0.12 0.06 0 0.24 0.09 0.23 a 48.1 48.1 0 0 1 10.38 0.44 A 0.23 0.23 0 0 0 133.39 159.82 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -120.3501 -73.8036)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-129.6498, -176.1964)",
    d: "M 134.9 176.66 c -3.19 -1.47 -7.42 -2 -10.58 -0.25 c -0.13 0.07 0 0.24 0.09 0.23 a 49.29 49.29 0 0 1 10.37 0.44 A 0.22 0.22 0 0 0 134.9 176.66 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -143.5641 -77.545)",
    id: "freepik--Shoes--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-106.4359, -172.455)",
    d: "M 106.43 154.81 c 0.15 2.95 0.23 5.89 0.29 8.83 s 0 5.88 0.08 8.82 s 0 5.88 -0.08 8.82 s -0.13 5.88 -0.29 8.82 c -0.16 -2.94 -0.23 -5.88 -0.29 -8.82 s -0.06 -5.88 -0.09 -8.82 s 0 -5.88 0.09 -8.82 S 106.27 157.76 106.43 154.81 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.52 49.365)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.08,
    y: -48.945,
    rx: 0,
    ry: 0,
    width: 4.16,
    height: 97.89
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.521 -47.14)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-370.521, -202.86)",
    d: "M 398.75 257.85 H 342.28 a 108.2 108.2 0 0 1 3.15 -23.3 c 2 -8 0.43 -16.64 0.49 -21.39 s -4.07 -26.86 -4.8 -28.94 s 2.23 -15.14 2.53 -16.47 s 17.66 -5.34 19.15 -8 s 1.48 -11.88 1.48 -11.88 h 12.47 s 0 9.2 1.48 11.88 s 18.86 6.68 19.15 8 s 3.28 14.4 2.54 16.47 s -4.87 24.2 -4.81 28.94 s -1.49 13.35 0.49 21.39 A 108.2 108.2 0 0 1 398.75 257.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.53 -99.3688)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-370.53, -150.6312)",
    d: "M 376.89 151.94 a 14.4 14.4 0 0 1 -6.38 1.46 a 12.27 12.27 0 0 1 -6.34 -1.62 c 0.12 -2.18 0.12 -3.92 0.12 -3.92 h 12.46 S 376.75 149.68 376.89 151.94 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.515 -116.745)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-370.515, -133.255)",
    d: "M 383.43 130.75 c 0 10.35 -4.79 20.26 -12.91 20.26 s -12.92 -9.91 -12.92 -20.26 c 0 -8.57 6.91 -15.25 12.92 -15.25 S 383.43 122.18 383.43 130.75 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.52 -34.885)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-370.52, -215.115)",
    d: "M 396.34 207.76 c -0.61 2.71 2 34.59 2.48 37.52 s 1.24 19.22 1.24 19.22 s -21.85 5.14 -29.28 5.15 S 341 264.5 341 264.5 s 0.78 -16.28 1.24 -19.22 s 3.08 -34.81 2.46 -37.52 s -3.94 -22.24 -4.25 -23.86 s 2.55 -16.21 3.1 -17.06 s 18.06 -6.26 18.06 -6.26 c -0.36 0.8 -2.78 8.42 -2.31 10 c 0.23 0.8 5.73 5.31 11.22 5.31 s 11 -4.51 11.24 -5.31 c 0.46 -1.63 -2 -9.25 -2.33 -10 c 0 0 17.54 5.41 18.07 6.26 s 3.4 15.45 3.09 17.06 S 397 205.06 396.34 207.76 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.52 -34.885)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-370.52, -215.115)",
    d: "M 396.34 207.76 c -0.61 2.71 2 34.59 2.48 37.52 s 1.24 19.22 1.24 19.22 s -21.85 5.14 -29.28 5.15 S 341 264.5 341 264.5 s 0.78 -16.28 1.24 -19.22 s 3.08 -34.81 2.46 -37.52 s -3.94 -22.24 -4.25 -23.86 s 2.55 -16.21 3.1 -17.06 s 18.06 -6.26 18.06 -6.26 c -0.36 0.8 -2.78 8.42 -2.31 10 c 0.23 0.8 5.73 5.31 11.22 5.31 s 11 -4.51 11.24 -5.31 c 0.46 -1.63 -2 -9.25 -2.33 -10 c 0 0 17.54 5.41 18.07 6.26 s 3.4 15.45 3.09 17.06 S 397 205.06 396.34 207.76 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 120.525 -35.29)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-370.525, -214.71)",
    d: "M 358.22 161.65 h 3 c -0.11 0.31 -0.23 0.69 -0.35 1.1 h -6.1 Z m 24.61 0 h -3 c 0.11 0.32 0.23 0.69 0.35 1.1 h 6.1 Z m -37.91 4.49 h 15 c 0.1 -0.37 0.19 -0.74 0.29 -1.1 H 347.9 C 346.72 165.45 345.68 165.83 344.92 166.14 Z m 48.24 -1.1 H 380.83 c 0.11 0.37 0.2 0.74 0.29 1.1 h 15 C 395.38 165.83 394.34 165.45 393.16 165 Z m -50.35 4.49 h 16.46 q 0 -0.5 0.15 -1.11 H 343.08 Z M 398 168.42 H 381.63 c 0.07 0.41 0.13 0.78 0.16 1.11 h 16.44 C 398.14 169.12 398.05 168.75 398 168.42 Z m -55.64 3.39 c -0.08 0.36 -0.15 0.73 -0.23 1.11 h 19.78 a 17 17 0 0 1 -1.49 -1.11 Z m 56.39 0 H 380.66 a 15.6 15.6 0 0 1 -1.49 1.11 h 19.77 C 398.87 172.54 398.79 172.17 398.72 171.81 Z m 0.66 3.39 H 374.63 a 11.73 11.73 0 0 1 -8.2 0 H 341.67 l -0.21 1.1 h 58.13 Z m 0.6 3.39 H 341.07 c -0.07 0.38 -0.13 0.75 -0.19 1.1 h 59.29 C 400.11 179.34 400.05 179 400 178.59 Z m 0.51 3.38 H 340.56 c 0 0.43 -0.08 0.8 -0.1 1.11 h 60.13 C 400.57 182.77 400.53 182.4 400.49 182 Z m -59.78 3.39 c 0.06 0.33 0.13 0.7 0.2 1.11 h 59.23 c 0.07 -0.41 0.14 -0.78 0.2 -1.11 Z m 0.59 3.39 c 0.07 0.35 0.13 0.72 0.19 1.1 h 58.06 c 0.07 -0.38 0.13 -0.75 0.19 -1.1 Z m 0.59 3.39 c 0.06 0.36 0.13 0.73 0.19 1.1 H 399 c 0.07 -0.37 0.13 -0.74 0.2 -1.1 Z m 0.59 3.38 c 0.06 0.37 0.13 0.74 0.19 1.11 h 55.7 c 0.07 -0.37 0.13 -0.74 0.19 -1.11 Z m 0.59 3.39 c 0.07 0.38 0.13 0.75 0.2 1.11 h 54.51 c 0.06 -0.36 0.13 -0.73 0.19 -1.11 Z m 0.61 3.39 c 0.06 0.38 0.13 0.75 0.19 1.1 h 53.31 c 0.06 -0.35 0.13 -0.72 0.19 -1.1 Z m 0.61 3.39 l 0.21 1.1 h 52.05 l 0.21 -1.1 Z m 52 4.49 c 0 -0.42 0 -0.79 0 -1.11 H 344.78 a 10.25 10.25 0 0 1 0 1.11 Z m 0.06 2.28 h -51.6 c 0 0.36 0 0.73 -0.05 1.11 h 51.7 C 396.35 213.18 396.34 212.81 396.32 212.46 Z m 0.16 3.39 H 344.56 q 0 0.54 -0.06 1.11 h 52 Z m 0.2 3.39 H 344.37 c 0 0.36 -0.05 0.73 -0.08 1.1 h 52.46 C 396.73 220 396.71 219.6 396.68 219.24 Z m 0.22 3.39 H 344.14 c 0 0.37 -0.05 0.73 -0.08 1.1 H 397 C 397 223.36 396.93 223 396.9 222.63 Z m 0.25 3.38 H 343.91 l -0.09 1.11 h 53.4 C 397.2 226.75 397.17 226.38 397.15 226 Z m 0.25 3.39 H 343.65 c 0 0.37 -0.06 0.74 -0.08 1.11 h 53.92 Z m 0.27 3.39 H 343.38 c 0 0.37 -0.05 0.74 -0.08 1.1 h 54.46 C 397.72 233.53 397.69 233.16 397.67 232.79 Z m 0.27 3.39 H 343.11 c 0 0.38 -0.06 0.74 -0.1 1.1 h 55 C 398 236.92 398 236.55 397.94 236.18 Z m 0.3 3.38 H 342.82 c 0 0.39 -0.07 0.76 -0.1 1.11 h 55.62 C 398.31 240.31 398.27 240 398.24 239.56 Z m 0.31 3.39 H 342.5 c 0 0.42 -0.08 0.79 -0.11 1.11 h 56.28 C 398.63 243.74 398.6 243.37 398.55 243 Z m 0.4 3.39 H 342.11 c 0 0.32 -0.06 0.69 -0.09 1.1 h 57 C 399 247 399 246.66 399 246.34 Z m 0.27 3.39 H 341.84 c 0 0.35 0 0.72 -0.08 1.1 H 399.3 C 399.27 250.45 399.25 250.08 399.22 249.73 Z m 0.22 3.38 H 341.62 c 0 0.36 -0.05 0.73 -0.06 1.11 H 399.5 C 399.49 253.84 399.46 253.47 399.44 253.11 Z m 0.2 3.39 H 341.42 l -0.06 1.11 H 399.7 Z m 0.19 3.39 h -58.6 c 0 0.38 0 0.75 -0.05 1.1 h 58.7 C 399.86 260.64 399.84 260.27 399.83 259.89 Z m 0.17 3.39 H 341.06 c 0 0.54 -0.05 0.92 -0.06 1.1 h 59.05 C 400.05 264.2 400 263.82 400 263.28 Z m -49 3.38 c 1.8 0.37 3.73 0.75 5.66 1.11 h 28 c 1.9 -0.36 3.79 -0.74 5.57 -1.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 84.5033 -38.2781)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-334.5033, -211.7219)",
    d: "M 343.55 166.84 c 0.81 -0.43 2.66 31.46 2.62 34.12 s -5.67 54.32 -6.37 55.36 s -16.36 -1 -16.94 -1.93 s 9.53 -70 9.65 -73 S 342.48 167.41 343.55 166.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 156.5517 -38.2781)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-406.5517, -211.7219)",
    d: "M 397.5 166.84 c -0.81 -0.43 -2.66 31.46 -2.62 34.12 s 5.67 54.32 6.37 55.36 s 16.37 -1 16.95 -1.93 s -9.54 -70 -9.66 -73 S 398.58 167.41 397.5 166.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 131.24 -136.52)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(55,71,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-381.24, -113.48)",
    d: "M 382.75 113.48 a 1.51 1.51 0 1 1 -1.51 -1.51 A 1.5 1.5 0 0 1 382.75 113.48 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 123.0041 -129.7821)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-373.0041, -120.218)",
    d: "M 383.47 127.59 c -0.67 -0.62 -9.88 -6.88 -12.19 -7.3 a 72.8 72.8 0 0 0 -11.08 -0.24 c -1.46 0.16 -4 -2.1 -3.29 -3.61 c 0.84 -1.76 5.56 -2 8.58 -2.63 s 11.68 -2.08 16.45 0.58 c 3.66 2 8 6.33 7.18 9.6 C 388.34 127 383.47 127.59 383.47 127.59 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.94 49.365)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -2.08,
    y: -48.945,
    rx: 0,
    ry: 0,
    width: 4.16,
    height: 97.89
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.9415 -47.14)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-265.9415, -202.86)",
    d: "M 294.17 257.85 H 237.7 a 108.2 108.2 0 0 1 3.15 -23.3 c 2 -8 0.43 -16.64 0.5 -21.39 s -4.07 -26.86 -4.81 -28.94 s 2.24 -15.14 2.53 -16.47 s 17.66 -5.34 19.15 -8 s 1.49 -11.88 1.49 -11.88 h 12.46 s 0 9.2 1.49 11.88 s 18.85 6.68 19.15 8 s 3.28 14.4 2.53 16.47 s -4.86 24.2 -4.81 28.94 s -1.48 13.35 0.5 21.39 A 108.53 108.53 0 0 1 294.17 257.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.95 -99.3688)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-265.95, -150.6312)",
    d: "M 272.31 151.94 a 14.32 14.32 0 0 1 -6.37 1.46 a 12.31 12.31 0 0 1 -6.35 -1.62 c 0.12 -2.18 0.12 -3.92 0.12 -3.92 h 12.47 S 272.18 149.68 272.31 151.94 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.925 -116.745)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-265.925, -133.255)",
    d: "M 278.85 130.75 c 0 10.35 -4.79 20.26 -12.9 20.26 S 253 141.1 253 130.75 c 0 -8.57 6.91 -15.25 12.93 -15.25 S 278.85 122.18 278.85 130.75 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.9293 -34.885)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-265.9292, -215.115)",
    d: "M 291.77 207.76 c -0.62 2.71 2 34.59 2.48 37.52 s 1.24 19.22 1.24 19.22 s -21.85 5.14 -29.29 5.15 s -29.78 -5.15 -29.78 -5.15 s 0.78 -16.28 1.24 -19.22 s 3.08 -34.81 2.47 -37.52 s -3.94 -22.24 -4.25 -23.86 s 2.55 -16.21 3.09 -17.06 S 257 160.58 257 160.58 c -0.36 0.8 -2.79 8.42 -2.31 10 s 8 10.26 8.41 10.42 s 2.3 9.76 2.81 9.76 s 2.34 -9.61 2.82 -9.76 s 7.94 -8.81 8.41 -10.42 s -2 -9.25 -2.32 -10 c 0 0 17.53 5.41 18.06 6.26 s 3.4 15.45 3.1 17.06 S 292.39 205.06 291.77 207.76 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.82 -13.3041)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-265.82, -236.6959)",
    d: "M 238.91 227 c -0.84 0.92 -2.24 15.72 -1.66 16.29 s 20.7 3.17 28.7 3.17 s 28.47 -3.95 28.57 -4.56 s -0.93 -15 -1.4 -14.9 s -23.88 5.41 -27.67 5.48 S 239.62 226.21 238.91 227 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -20.0417 -38.2781)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-229.9583, -211.7219)",
    d: "M 239 166.84 c 0.81 -0.43 2.67 31.46 2.63 34.12 s -5.68 54.32 -6.37 55.36 s -16.37 -1 -16.95 -1.93 s 9.54 -70 9.65 -73 S 237.9 167.41 239 166.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.9717 -38.2781)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-301.9717, -211.7219)",
    d: "M 292.93 166.84 c -0.81 -0.43 -2.67 31.46 -2.63 34.12 s 5.68 54.32 6.37 55.36 s 16.37 -1 16.95 -1.93 s -9.54 -70 -9.65 -73 S 294 167.41 292.93 166.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2664 -0.9639 0.9639 0.2664 15.9512 -67.5719)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -0.18,
    y: -3.985,
    rx: 0,
    ry: 0,
    width: 0.36,
    height: 7.97
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9639 -0.2662 0.2662 0.9639 15.9352 -67.5463)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.985,
    y: -0.18,
    rx: 0,
    ry: 0,
    width: 7.97,
    height: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2664 -0.9639 0.9639 0.2664 15.9642 -65.4344)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -0.18,
    y: -3.985,
    rx: 0,
    ry: 0,
    width: 0.36,
    height: 7.97
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9639 -0.2664 0.2664 0.9639 15.9383 -65.4361)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.985,
    y: -0.18,
    rx: 0,
    ry: 0,
    width: 7.97,
    height: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2664 -0.9639 0.9639 0.2664 15.9576 -63.3197)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -0.18,
    y: -3.985,
    rx: 0,
    ry: 0,
    width: 0.36,
    height: 7.97
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9639 -0.2664 0.2664 0.9639 15.9457 -63.3131)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.985,
    y: -0.18,
    rx: 0,
    ry: 0,
    width: 7.97,
    height: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.2666 -0.9638 0.9638 0.2666 15.9569 -61.2008)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -0.18,
    y: -3.985,
    rx: 0,
    ry: 0,
    width: 0.36,
    height: 7.97
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9639 -0.2662 0.2662 0.9639 15.9411 -61.1762)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(219,219,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -3.985,
    y: -0.18,
    rx: 0,
    ry: 0,
    width: 7.97,
    height: 0.36
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.076 -40.2707)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-246.924, -209.7293)",
    d: "M 253.41 161.36 c -0.18 -0.5 -11 1.91 -14.2 4.78 c -2 1.74 2.3 32.18 2.08 34.82 s -5.39 54.45 -5.18 56.89 s 18.31 -10 20.62 -13.5 S 257.18 171.76 253.41 161.36 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 34.9761 -40.2707)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-284.976, -209.7293)",
    d: "M 278.49 161.36 c 0.18 -0.5 11 1.91 14.2 4.78 c 2 1.74 -2.29 32.18 -2.08 34.82 s 5.39 54.45 5.18 56.89 s -18.31 -10 -20.62 -13.5 S 274.72 171.76 278.49 161.36 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.6451 -79.1816)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-251.645, -170.8184)",
    d: "M 263.14 181 c -0.78 0.16 -9.24 -7 -10.12 -7 c -1.31 0 -9.65 4.71 -10 5.4 s -0.31 2.94 -0.78 2.71 s -1.77 -4.1 -2.08 -5.79 s 6.72 -12.82 8.26 -13.9 s 9.85 -3.64 9.83 -2.71 s -1.18 9.89 -0.64 11.66 S 263.14 181 263.14 181 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.255 -79.1816)",
    id: "freepik--Mannequins--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-280.255, -170.8184)",
    d: "M 268.76 181 c 0.77 0.16 9.24 -7 10.12 -7 c 1.31 0 9.65 4.71 10 5.4 s 0.31 2.94 0.78 2.71 s 1.77 -4.1 2.08 -5.79 s -6.72 -12.82 -8.26 -13.9 s -9.85 -3.64 -9.83 -2.71 s 1.18 9.89 0.64 11.66 S 268.76 181 268.76 181 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 162.845)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-207.71,-0.005 -155.79,-0.245 -103.86,-0.335 0,-0.495 103.86,-0.335 155.79,-0.245 207.71,-0.005 155.79,0.245 103.86,0.335 0,0.495 -103.86,0.335 -155.79,0.245 -207.71,-0.005 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.005 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -201.135,
    y: -2.915,
    rx: 0,
    ry: 0,
    width: 402.27,
    height: 5.83
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -172.9304 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-77.0696, -410.095)",
    d: "M 77.07 407.18 a 8.46 8.46 0 0 1 0.48 2.91 a 8.25 8.25 0 0 1 -0.48 2.92 a 8 8 0 0 1 -0.48 -2.92 A 8.23 8.23 0 0 1 77.07 407.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -141.49 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-108.51, -410.095)",
    d: "M 108.51 407.18 a 9.09 9.09 0 0 1 0 5.83 a 9.09 9.09 0 0 1 0 -5.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.9991 160.085)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-140.0009, -410.085)",
    d: "M 140 407.18 a 8.23 8.23 0 0 1 0.48 2.91 A 8 8 0 0 1 140 413 a 9.09 9.09 0 0 1 0 -5.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -78.605 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-171.3949, -410.095)",
    d: "M 171.39 407.18 a 9.09 9.09 0 0 1 0 5.83 a 9.27 9.27 0 0 1 0 -5.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -47.1637 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-202.8364, -410.095)",
    d: "M 202.84 407.18 a 8.21 8.21 0 0 1 0.47 2.91 a 8 8 0 0 1 -0.47 2.92 a 9.09 9.09 0 0 1 0 -5.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -15.721 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-234.279, -410.095)",
    d: "M 234.28 407.18 a 9.09 9.09 0 0 1 0 5.83 a 8 8 0 0 1 -0.48 -2.92 A 8.23 8.23 0 0 1 234.28 407.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.721 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-265.721, -410.095)",
    d: "M 265.72 407.18 a 8.23 8.23 0 0 1 0.48 2.91 a 8 8 0 0 1 -0.48 2.92 a 9.09 9.09 0 0 1 0 -5.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 47.1636 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-297.1636, -410.095)",
    d: "M 297.16 407.18 a 9.09 9.09 0 0 1 0 5.83 a 8 8 0 0 1 -0.47 -2.92 A 8.21 8.21 0 0 1 297.16 407.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 78.6051 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-328.6051, -410.095)",
    d: "M 328.61 407.18 a 9.27 9.27 0 0 1 0 5.83 a 9.09 9.09 0 0 1 0 -5.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.049 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-360.049, -410.095)",
    d: "M 360.05 407.18 a 9.09 9.09 0 0 1 0 5.83 a 8 8 0 0 1 -0.48 -2.92 A 8.23 8.23 0 0 1 360.05 407.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 141.49 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-391.49, -410.095)",
    d: "M 391.49 407.18 a 9.09 9.09 0 0 1 0 5.83 a 9.09 9.09 0 0 1 0 -5.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 172.9305 160.095)",
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-422.9304, -410.095)",
    d: "M 422.93 407.18 a 8.23 8.23 0 0 1 0.48 2.91 a 8 8 0 0 1 -0.48 2.92 a 8.25 8.25 0 0 1 -0.48 -2.92 A 8.46 8.46 0 0 1 422.93 407.18 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.6598 177.2884)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-263.6598, -427.2884)",
    d: "M 231.15 394.43 s -3 41.07 -3 41.1 c 0 8 0.06 15.1 0.46 18.74 a 0.13 0.13 0 0 0 0 0.06 a 5.62 5.62 0 0 0 0.58 2.49 l 0 0.05 c 2.39 1.63 66.67 3.83 68.93 3.15 s 0.52 -7.19 -1.91 -9.27 s -26.67 -13.92 -26.67 -13.92 l 2.56 -41.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.758 190.0984)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-263.758, -440.0984)",
    d: "M 298.22 460 c -2.27 0.68 -66.54 -1.52 -68.93 -3.16 l 0 -0.05 a 5.67 5.67 0 0 1 -0.58 -2.48 a 0.13 0.13 0 0 1 0 -0.06 c -0.39 -3.65 -0.5 -10.7 -0.46 -18.74 c 0 0 0.51 -7.13 1.11 -15.44 L 270.56 422 l -0.92 14.81 s 24.22 11.85 26.66 13.92 S 300.49 459.35 298.22 460 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.657 192.0034)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-263.6571, -442.0034)",
    d: "M 298.5 460.13 c -2.31 0.68 -67.58 -1.13 -70 -2.8 c -0.93 -0.63 -1.14 -22.51 0.18 -33.6 l 42.05 1.64 s -0.06 11.28 0.44 11.53 c 4.13 2.12 23.23 11.93 25.43 13.81 C 299 452.82 300.81 459.45 298.5 460.13 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.7625 206.445)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-264.7625, -456.445)",
    d: "M 297.66 457.48 c -10.92 -0.68 -55.05 -2.4 -65.9 -2.24 c -0.09 0 -0.09 0.06 0 0.07 c 10.81 0.91 54.95 2.27 65.9 2.35 C 297.89 457.67 297.89 457.5 297.66 457.48 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 37.8651 202.3026)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-287.8651, -452.3026)",
    d: "M 292.48 448.2 a 8.8 8.8 0 0 0 -6.64 2.43 a 8.49 8.49 0 0 0 -2.67 5.74 c 0 0.07 0.12 0.07 0.13 0 a 10.16 10.16 0 0 1 9.17 -8 A 0.07 0.07 0 0 0 292.48 448.2 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 17.7172 190.1394)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-267.7172, -440.1394)",
    d: "M 273.77 437.73 c -4.38 -0.23 -9.51 1.13 -12.37 4.6 c -0.11 0.14 0.09 0.29 0.22 0.23 a 60.32 60.32 0 0 1 12.2 -4.29 A 0.27 0.27 0 0 0 273.77 437.73 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.027 191.5851)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-271.0271, -441.585)",
    d: "M 277.09 439.17 c -4.37 -0.22 -9.5 1.13 -12.36 4.61 c -0.11 0.13 0.08 0.29 0.22 0.23 a 60.32 60.32 0 0 1 12.2 -4.29 A 0.28 0.28 0 0 0 277.09 439.17 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 24.3744 193.0294)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-274.3744, -443.0294)",
    d: "M 280.42 440.62 c -4.37 -0.23 -9.5 1.13 -12.36 4.6 c -0.11 0.14 0.08 0.29 0.22 0.23 a 60.32 60.32 0 0 1 12.2 -4.29 A 0.27 0.27 0 0 0 280.42 440.62 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 27.6871 194.4751)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-277.687, -444.475)",
    d: "M 283.75 442.06 c -4.37 -0.22 -9.5 1.13 -12.36 4.61 c -0.11 0.13 0.08 0.29 0.21 0.23 a 60.62 60.62 0 0 1 12.21 -4.29 A 0.28 0.28 0 0 0 283.75 442.06 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.6731 181.82)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-235.3268, -431.82)",
    d: "M 235.46 428 c -4.91 -0.17 -5.19 7.47 -0.27 7.64 S 240.38 428.21 235.46 428 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 24.0748 182.4377)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-274.0748, -432.4377)",
    d: "M 278.93 426.23 c -2.14 -1.92 -5 -0.24 -6.43 1.62 a 19.46 19.46 0 0 0 -1.77 2.76 a 23.27 23.27 0 0 0 -2.47 7.13 a 3.43 3.43 0 0 0 -0.08 0.56 a 0.21 0.21 0 0 0 0 0.15 c 0 0.16 -0.05 0.31 -0.07 0.45 a 0.12 0.12 0 0 0 0.14 0.12 a 0.57 0.57 0 0 0 0.43 0.44 a 0.43 0.43 0 0 0 0.34 0 c 0.88 -0.56 1.8 -1.11 2.73 -1.67 l 0.49 -0.29 a 24 24 0 0 0 6.12 -4.82 C 279.8 430.9 281 428 278.93 426.23 Z m -5.71 9.1 l -2.15 1.39 c -0.69 0.45 -1.37 0.9 -2 1.38 a 1.5 1.5 0 0 0 -0.23 0.15 c -0.07 0.06 -0.16 0.11 -0.24 0.17 c 0 -0.09 0.07 -0.16 0.1 -0.25 v 0 c 0.69 -1.71 1.31 -3.45 2.12 -5.1 c 0.14 -0.34 0.32 -0.67 0.49 -1 a 23.27 23.27 0 0 1 1.7 -2.89 c 1 -1.4 5.45 -4.91 5.69 -0.13 C 278.82 431.65 275.06 434.09 273.22 435.33 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.8787 186.5065)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-260.8787, -436.5065)",
    d: "M 269.05 438.68 a 0.13 0.13 0 0 0 0 -0.19 l -0.26 -0.24 l -0.08 -0.09 s 0 0 -0.05 0 l -0.42 -0.39 a 23.19 23.19 0 0 0 -9.58 -5 c -2.29 -0.54 -5.56 0 -6 2.8 s 2.29 4.17 4.5 4.59 a 21.41 21.41 0 0 0 6.78 0 c 1.59 -0.2 3.18 -0.46 4.72 -0.65 h 0 A 0.53 0.53 0 0 0 269.05 438.68 Z m -6.22 0.28 c -2.2 0.21 -6.66 0.69 -8.22 -1.44 c -2.81 -3.88 2.83 -4 4.49 -3.51 a 25.49 25.49 0 0 1 3.16 1.17 a 61.76 61.76 0 0 1 5.91 3.12 h 0 l 0.22 0.13 l -0.24 0 l -0.66 0 C 266 438.62 264.4 438.82 262.83 439 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.5467 65.75)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(55,71,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-249.4533, -315.75)",
    d: "M 228.11 417.71 l 45.95 1.89 s 2.13 -64.15 1.11 -91.15 c -1.11 -29.31 -13.71 -116.55 -13.71 -116.55 h -38 s 9.71 87.58 9.91 116.91 C 233.58 356 228.11 417.71 228.11 417.71 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.265 1.4)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.735, -251.4)",
    d: "M 254 211.9 l -22.83 79 c -2.7 -37.37 -7.7 -79 -7.7 -79 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.9067 61.605)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-235.0933, -311.605)",
    d: "M 230.68 216.2 l 2.41 26 l 2.24 26.06 c 1.43 17.37 2.79 34.75 3.82 52.17 c 0.25 4.35 0.41 8.72 0.34 13.1 s -0.26 8.72 -0.48 13.08 q -0.67 13.07 -1.68 26.1 c -0.66 8.7 -3.09 34.3 -3.09 34.3 s 1.76 -25.65 2.33 -34.35 s 1.13 -17.39 1.54 -26.1 c 0.2 -4.35 0.36 -8.7 0.44 -13.05 s -0.12 -8.68 -0.39 -13 c -0.95 -17.4 -2.32 -34.78 -3.59 -52.16 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.027 160.1145)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-252.027, -410.1145)",
    d: "M 272.63 411 c -7 -0.47 -5 -0.44 -12 -0.83 c -3.44 -0.2 -26 -1.46 -29.22 -1.08 a 0.08 0.08 0 0 0 0 0.15 c 3.18 0.68 25.76 1.54 29.19 1.67 c 7 0.26 5 0.11 12 0.3 A 0.11 0.11 0 0 0 272.63 411 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -88.57 165.4587)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-161.43, -415.4587)",
    d: "M 158.14 371.14 l -21 35.47 c -3.62 7.18 -6.67 13.55 -7.94 17 a 0.14 0.14 0 0 0 0 0.06 a 5.71 5.71 0 0 0 -0.59 2.49 s 0 0.05 0 0.06 c 1.41 2.53 58 33.14 60.3 33.54 s 3.67 -6.21 2.42 -9.15 s -17.67 -24.34 -17.67 -24.34 l 20.59 -35.62 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -89.6969 176.5491)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,235,235)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-160.3031, -426.5491)",
    d: "M 189 459.75 c -2.33 -0.41 -58.89 -31 -60.3 -33.55 a 0.64 0.64 0 0 1 0 -0.07 a 5.7 5.7 0 0 1 0.59 -2.48 a 0.43 0.43 0 0 1 0 0 c 1.28 -3.44 4.33 -9.81 7.94 -17 l 7.88 -13.32 l 36.07 20.11 l -7.42 12.85 s 16.4 21.4 17.67 24.34 S 191.28 460.16 189 459.75 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -90.0953 178.1531)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-159.9047, -428.1531)",
    d: "M 189.16 460 c -2.37 -0.43 -60 -31.13 -61.43 -33.71 c -0.55 -1 9 -20.66 15.13 -30 l 36.92 20.21 S 174.7 426.54 175 427 c 2.75 3.74 15.47 21 16.6 23.69 C 192.9 453.67 191.53 460.39 189.16 460 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -89.3873 191.6342)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-160.6128, -441.6342)",
    d: "M 189.59 457.23 c -9.48 -5.48 -48.21 -26.69 -58 -31.38 c -0.08 0 -0.11 0 0 0.06 c 9.27 5.63 48.18 26.52 57.94 31.47 C 189.71 457.49 189.79 457.34 189.59 457.23 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -66.8789 197.6414)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-183.1211, -447.6414)",
    d: "M 189.08 446.61 a 8.75 8.75 0 0 0 -7 -0.79 a 8.52 8.52 0 0 0 -4.95 3.95 c 0 0.06 0.08 0.12 0.12 0.07 A 10.15 10.15 0 0 1 189 446.73 A 0.07 0.07 0 0 0 189.08 446.61 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -79.5325 177.9818)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-170.4675, -427.9818)",
    d: "M 177 428.89 c -3.82 -2.15 -9 -3.23 -13.12 -1.39 c -0.16 0.08 0 0.3 0.09 0.3 a 61.06 61.06 0 0 1 12.84 1.6 A 0.28 0.28 0 0 0 177 428.89 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -77.1978 180.7627)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-172.8022, -430.7627)",
    d: "M 179.34 431.67 c -3.82 -2.15 -9 -3.23 -13.12 -1.39 c -0.16 0.07 -0.06 0.3 0.09 0.3 a 60.39 60.39 0 0 1 12.83 1.6 A 0.28 0.28 0 0 0 179.34 431.67 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -74.841 183.5482)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-175.1591, -433.5482)",
    d: "M 181.67 434.45 c -3.81 -2.16 -9 -3.23 -13.12 -1.39 c -0.16 0.07 -0.05 0.29 0.09 0.3 a 59.77 59.77 0 0 1 12.84 1.6 A 0.27 0.27 0 0 0 181.67 434.45 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.5391 186.3153)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-177.4609, -436.3154)",
    d: "M 184 437.22 c -3.82 -2.15 -9 -3.22 -13.12 -1.38 c -0.16 0.07 -0.06 0.29 0.09 0.3 a 60.47 60.47 0 0 1 12.84 1.59 A 0.28 0.28 0 0 0 184 437.22 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -104.8181 156.5015)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-145.1819, -406.5016)",
    d: "M 147 403.14 c -4.32 -2.34 -8 4.37 -3.64 6.72 S 151.35 405.49 147 403.14 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -70.8136 173.5222)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-179.1863, -423.5222)",
    d: "M 186.74 420.9 c -1.05 -2.67 -4.36 -2.44 -6.47 -1.41 a 18.38 18.38 0 0 0 -2.82 1.68 a 23.43 23.43 0 0 0 -5.38 5.27 a 3.73 3.73 0 0 0 -0.33 0.48 a 0.18 0.18 0 0 0 -0.08 0.12 c -0.1 0.13 -0.18 0.25 -0.26 0.37 a 0.11 0.11 0 0 0 0.07 0.17 a 0.57 0.57 0 0 0 0.19 0.59 a 0.4 0.4 0 0 0 0.32 0.1 l 3.19 -0.28 l 0.57 0 a 24 24 0 0 0 7.63 -1.59 C 185.44 425.47 187.77 423.43 186.74 420.9 Z m -9.16 5.6 l -2.55 0.29 c -0.81 0.09 -1.63 0.19 -2.43 0.32 l -0.27 0 l -0.29 0 l 0.2 -0.17 l 0 0 c 1.37 -1.23 2.71 -2.51 4.17 -3.63 c 0.28 -0.23 0.58 -0.45 0.88 -0.67 a 24.59 24.59 0 0 1 2.81 -1.83 c 1.53 -0.81 7.07 -2 5.16 2.42 C 184.24 425.7 179.78 426.21 177.58 426.5 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -84.5147 172.177)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-165.4852, -422.177)",
    d: "M 172.35 427.64 c 0.08 0 0.13 -0.08 0.1 -0.16 a 1.85 1.85 0 0 0 -0.12 -0.33 l 0 -0.12 s 0 0 0 0 c -0.06 -0.19 -0.13 -0.37 -0.2 -0.55 a 23.21 23.21 0 0 0 -6.34 -8.76 c -1.81 -1.5 -5 -2.52 -6.64 -0.17 s 0.19 4.75 2 6.11 a 21.49 21.49 0 0 0 6.06 3 c 1.51 0.53 3.05 1 4.52 1.53 h 0 A 0.54 0.54 0 0 0 172.35 427.64 Z m -5.69 -2.52 c -2.06 -0.79 -6.27 -2.35 -6.72 -4.95 c -0.79 -4.72 4.3 -2.29 5.59 -1.14 a 26.76 26.76 0 0 1 2.31 2.45 a 63.07 63.07 0 0 1 3.89 5.43 h 0 a 2.43 2.43 0 0 1 0.14 0.2 l -0.22 -0.08 l -0.61 -0.26 C 169.6 426.2 168.13 425.69 166.66 425.12 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -48.615 62.13)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(55,71,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-201.385, -312.13)",
    d: "M 257.57 211.87 v 0 c -0.17 0.78 -2.83 13.1 -5.58 23.69 c -2 7.74 -4.07 14.54 -5.25 15.24 c -1.34 0.79 -7.86 3.68 -10.05 4.59 c 0 0 -14.67 73.25 -22.42 96 c -7.15 21 -27.34 61 -27.34 61 L 145.2 389.34 s 22.94 -39.5 26.46 -49.7 c 5.47 -15.82 25.94 -93 25.94 -93 s -0.16 -24.18 8 -34.73 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -79.5482 143.2943)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-170.4518, -393.2943)",
    d: "M 188.72 402.86 c -6.14 -3.42 -4.33 -2.52 -10.5 -5.88 c -3 -1.64 -22.87 -12.42 -26 -13.46 c -0.06 0 -0.12 0.08 -0.06 0.13 c 2.58 2 22.62 12.4 25.67 14 c 6.23 3.24 4.48 2.24 10.75 5.41 C 188.74 403.11 188.83 402.93 188.72 402.86 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -32.3032 -17.6594)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-217.6968, -232.3406)",
    d: "M 208.61 239.87 c 1.17 -0.3 2.43 -0.39 3.63 -0.58 c 1 -0.16 1.93 -0.33 2.89 -0.54 a 12.8 12.8 0 0 0 5.1 -2.14 c 1.66 -1.3 2.5 -3.26 3.3 -5.14 c 0.48 -1.12 1 -2.23 1.47 -3.34 c 0.24 -0.54 0.49 -1.08 0.74 -1.61 a 18.69 18.69 0 0 0 0.9 -1.93 c 0 -0.1 0.19 -0.05 0.15 0 a 13.79 13.79 0 0 0 -0.41 1.39 l -0.48 1.62 c -0.3 1 -0.59 1.93 -0.91 2.88 a 23.13 23.13 0 0 1 -2 5 c -1.78 2.83 -4.94 4 -8.11 4.36 c -0.91 0.12 -1.82 0.18 -2.74 0.23 a 19 19 0 0 1 -3.46 0 A 0.16 0.16 0 0 1 208.61 239.87 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.3573 2.3831)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.6427, -252.3831)",
    d: "M 250.22 249.11 a 85.66 85.66 0 0 0 -13.46 6.26 c -0.16 0.1 0 0.36 0.13 0.28 c 4.53 -1.94 9.15 -3.81 13.57 -6 A 0.3 0.3 0 0 0 250.22 249.11 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.9084 -16.8874)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-247.0916, -233.1125)",
    d: "M 251.58 218.07 c 0 -0.15 -0.29 -0.19 -0.29 0 a 148.24 148.24 0 0 1 -0.76 15.14 c -0.21 2.34 -2.08 15.23 -6.13 14.29 c -0.68 -0.15 -1 -0.82 -1.13 -1.84 a 15.8 15.8 0 0 1 0.54 -4 c 0.45 -2.7 0.81 -5.41 1 -8.13 a 74.11 74.11 0 0 0 -0.17 -15.26 a 0.13 0.13 0 0 0 -0.26 0 a 140 140 0 0 1 -1.23 21.07 c -0.51 3.35 -2.2 8.4 1.31 8.92 s 5.89 -7.94 6.32 -10.25 A 77.2 77.2 0 0 0 251.58 218.07 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.6967 0.1775)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-244.3034, -250.1775)",
    d: "M 244.51 247.83 a 21.54 21.54 0 0 0 -0.91 2.67 a 6 6 0 0 0 -0.38 2.2 c 0 0.14 0.2 0.16 0.28 0.06 a 7.91 7.91 0 0 0 0.94 -2.14 c 0.31 -0.82 0.63 -1.64 0.92 -2.48 A 0.45 0.45 0 0 0 244.51 247.83 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -68.5605 49.4262)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-181.4395, -299.4262)",
    d: "M 155.6 383.59 c 6.1 -11.5 15.7 -29.45 18.68 -35.14 a 102 102 0 0 0 6.79 -17.57 q 5.67 -18.42 10.74 -37 t 9.51 -37.36 c 0.75 -3.13 1.57 -6.25 2.17 -9.41 a 28.83 28.83 0 0 0 0 -9.63 a 31 31 0 0 1 -0.07 -9 a 59.86 59.86 0 0 1 2.1 -8.77 c 0.48 -1.51 1 -3 1.51 -4.5 a 0.14 0.14 0 0 1 0.26 0.08 c -1.85 6 -3.74 12.17 -3.34 18.58 c 0.19 3.09 1 6.11 0.95 9.21 a 43.43 43.43 0 0 1 -1.56 9.11 q -4.37 18.85 -9.4 37.57 T 183.3 327 c -1.82 6 -3.53 12.11 -6.11 17.85 s -12.37 23.32 -18.94 34.55 l -2.52 4.26 C 155.68 383.77 155.55 383.68 155.6 383.59 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.3558 -79.3926)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-280.3558, -170.6074)",
    d: "M 243.12 152.14 c 3.65 15.46 12.41 38.07 18.44 45 c 6.71 7.75 37.1 0.21 55.84 -5 c 3.73 -1 -3.3 -29.44 -7.22 -28.14 c -10.24 3.42 -31.93 12 -34 10.82 c -1.73 -1 -15 -16.54 -21.79 -25.71 C 243.56 134.56 240.54 141.25 243.12 152.14 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.628 -83.5964)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-319.6281, -166.4037)",
    d: "M 309.63 192.52 c -3.3 -0.73 -7.29 -22.6 -5 -25.18 a 13.35 13.35 0 0 1 2.83 -2 h 0 a 49.26 49.26 0 0 0 7.17 -12.43 c 1.93 -5.4 4.18 -13.64 7.12 -12.71 c 4.29 1.34 2.7 12.1 1.42 18.22 c 3.24 -1 6.13 -1.59 7.93 -1.31 c 6 0.93 5.23 28.23 -0.12 31.3 C 325.85 191.35 312.92 193.26 309.63 192.52 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 92.89 -31.215)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "29.4,21.705 -25.95,33.025 -29.4,-25.005 9.8,-33.025 29.4,21.705 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 112.49 -35.42)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(55,71,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-9.8,-28.82 -4.42,28.82 9.8,25.91 -9.8,-28.82 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 82.415 -64.0939)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-332.415, -185.9062)",
    d: "M 325.32 195.41 h -1.8 c 0 -0.05 0 -5 0.12 -10 a 9.37 9.37 0 0 1 9.09 -9 c 3.28 -0.14 7.31 1.62 7.87 7 c 0.59 5.79 0.71 8.55 0.71 8.67 l -1.8 0.07 s -0.12 -2.83 -0.71 -8.56 c -0.42 -4.15 -3.37 -5.52 -6 -5.41 a 7.56 7.56 0 0 0 -7.35 7.24 C 325.35 190.43 325.32 195.36 325.32 195.41 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 115.155 -10.19)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-365.155, -239.81)",
    d: "M 358.73 242.81 c 1 -1 2 -2 3 -3 s 2.08 -1.93 3.15 -2.87 l 0.15 -0.13 l 0.17 0.09 c 1.08 0.51 2.16 1 3.22 1.57 s 2.12 1.1 3.16 1.7 c -1.13 -0.4 -2.24 -0.84 -3.35 -1.3 s -2.19 -0.94 -3.28 -1.44 l 0.32 0 c -1.06 1 -2.13 1.87 -3.22 2.78 S 359.88 242 358.73 242.81 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 109.95 -34.275)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-359.95, -215.725)",
    d: "M 365.1 237.17 c -1 -3.55 -1.89 -7.11 -2.79 -10.67 s -1.77 -7.14 -2.65 -10.71 s -1.7 -7.15 -2.51 -10.74 l -1.2 -5.38 c -0.38 -1.8 -0.78 -3.59 -1.15 -5.39 c 0.5 1.77 1 3.55 1.43 5.32 l 1.37 5.34 c 0.91 3.57 1.76 7.14 2.65 10.71 s 1.69 7.15 2.5 10.74 S 364.37 233.56 365.1 237.17 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 74.4188 -54.5985)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-324.4188, -195.4015)",
    d: "M 326.77 194.92 a 2.4 2.4 0 1 1 -2.83 -1.87 A 2.4 2.4 0 0 1 326.77 194.92 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 90.2288 -57.8285)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-340.2288, -192.1715)",
    d: "M 342.58 191.69 a 2.4 2.4 0 1 1 -2.83 -1.87 A 2.4 2.4 0 0 1 342.58 191.69 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 70.895 -81.695)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "11.685,-16.475 9.065,16.475 -9.065,16.475 -11.685,-16.475 11.685,-16.475 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 70.82 -98.74)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(69,90,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -13.32,
    y: -2.4,
    rx: 0,
    ry: 0,
    width: 26.64,
    height: 4.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 70.815 -103.84)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(55,71,79)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "11.495,2.7 -11.495,2.7 -10.145,-2.7 10.155,-2.7 11.495,2.7 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 70.895 -81.405)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-320.895, -168.595)",
    d: "M 327.19 168.6 c 0 4.27 -2.82 7.74 -6.29 7.74 s -6.3 -3.47 -6.3 -7.74 s 2.82 -7.75 6.3 -7.75 S 327.19 164.32 327.19 168.6 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.2787 -78.9353)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-330.2788, -171.0647)",
    d: "M 321.61 157.49 c -1.53 2.76 2.6 3 2.6 3 s -6 1.1 -6.5 4.56 s 4.54 3.42 4.9 3.43 c -0.32 0.06 -5.82 1.22 -5.95 4.74 s 4.91 2.9 5.23 2.85 c -0.28 0.15 -4 2.22 -3.46 4.92 c 0.89 4.63 10.47 -0.41 14.07 0.87 c 0 0 -1.48 6.34 -1.49 6.53 c 0 0 9.22 -4.61 10.69 -9.55 a 3.29 3.29 0 0 0 -1.51 -3.84 s 3.14 -1.16 3.32 -3.92 c 0.09 -1.43 -2.1 -2.84 -2.1 -2.84 a 4.14 4.14 0 0 0 2.49 -3.5 c 0 -2 -2.19 -3.08 -2.19 -3.08 s 1.92 -2.09 1.28 -4.11 C 341.71 153.46 324.89 151.59 321.61 157.49 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 82.629 -89.5281)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-332.6291, -160.4719)",
    d: "M 341.39 161.42 c 0.05 0 0.08 -0.06 0 -0.08 a 29.35 29.35 0 0 0 -17.44 -0.9 c -0.18 0.05 -0.17 0.37 0 0.35 A 60.22 60.22 0 0 1 341.39 161.42 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 81.8826 -82.4543)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-331.8826, -167.5457)",
    d: "M 341.5 168.21 c 0.06 0 0.08 -0.09 0 -0.12 a 27.49 27.49 0 0 0 -19.08 0.21 c -0.21 0.08 -0.31 0.38 -0.06 0.29 C 326.61 167.2 336.14 167.14 341.5 168.21 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.7029 -75.039)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-330.7029, -174.961)",
    d: "M 321.52 176.39 c 6 -2.24 12.14 -2.32 18.44 -1.5 c 0.09 0 0.09 -0.1 0 -0.13 c -3 -1.24 -7.05 -1.35 -10.22 -1.16 a 17 17 0 0 0 -8.33 2.57 C 321.34 176.24 321.39 176.43 321.52 176.39 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 74.307 -78.1584)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-324.307, -171.8416)",
    d: "M 324.12 160.41 c -0.22 0.06 0.11 0.31 -0.1 0.38 c -0.91 0.29 -6.23 2.51 -6 4.56 c 0.16 1.64 2.48 2.56 3.5 2.57 l 2.59 0 l -2.44 0.88 a 10.58 10.58 0 0 0 -3 1.65 a 3.76 3.76 0 0 0 -1.59 2.65 a 2.16 2.16 0 0 0 1.47 2.29 a 6.54 6.54 0 0 0 3.27 0.15 l 3 -0.53 l -2.67 1.48 a 9.93 9.93 0 0 0 -2 1.5 a 4.09 4.09 0 0 0 -1.25 2 a 2 2 0 0 0 0.68 1.94 a 4.25 4.25 0 0 0 2.33 0.59 a 34.21 34.21 0 0 0 5.29 -0.52 c 0.89 -0.13 1.78 -0.26 2.68 -0.34 a 6.39 6.39 0 0 1 2.68 0.16 a 6.76 6.76 0 0 0 -2.65 0.09 c -0.88 0.15 -1.76 0.34 -2.63 0.53 a 28.88 28.88 0 0 1 -5.37 0.82 a 5.07 5.07 0 0 1 -2.82 -0.62 a 2.76 2.76 0 0 1 -1.11 -2.82 a 5 5 0 0 1 1.48 -2.54 a 10.73 10.73 0 0 1 2.25 -1.7 l 0.35 0.95 a 7.61 7.61 0 0 1 -3.87 -0.14 a 3.15 3.15 0 0 1 -1.66 -1.32 a 3.61 3.61 0 0 1 -0.47 -2 a 4.8 4.8 0 0 1 2 -3.36 a 11.83 11.83 0 0 1 3.33 -1.76 l 0.15 0.9 c -1.31 -0.05 -4 -0.8 -4.57 -3.32 C 316.68 162.14 323 160.61 324.12 160.41 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 72.5146 -91.9919)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-322.5147, -158.0081)",
    d: "M 324.21 160.48 a 6.48 6.48 0 0 1 -1.79 -0.76 a 1.48 1.48 0 0 1 -0.72 -1.3 a 3 3 0 0 1 0.74 -1.52 c 0.4 -0.49 0.85 -1 1.33 -1.48 a 5 5 0 0 0 -1.83 1 a 2.94 2.94 0 0 0 -1.12 2 a 2.1 2.1 0 0 0 0.34 1.2 a 2.14 2.14 0 0 0 0.94 0.74 A 3.35 3.35 0 0 0 324.21 160.48 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 26.4859 -78.6483)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-276.4859, -171.3517)",
    d: "M 304 165.13 l 8.06 32.22 s -36.61 9.87 -49.61 2.51 c -5.36 -3 -17.4 -35.6 -20.49 -47.08 s 0.57 -19 12.07 -5.26 s 22.19 25.64 23.4 25.61 S 304 165.13 304 165.13 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.4125 -67.002)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-301.4125, -182.998)",
    d: "M 297.82 169.57 a 67.34 67.34 0 0 0 1.41 6.6 c 0.53 2.27 1.13 4.52 1.72 6.78 s 3.24 11.18 3.9 13.41 a 0.08 0.08 0 1 0 0.15 0 c -0.52 -2.28 -2.59 -11.28 -3.18 -13.48 s -1.16 -4.42 -1.81 -6.62 a 67.6 67.6 0 0 0 -2.09 -6.66 C 297.9 169.51 297.82 169.51 297.82 169.57 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 9.974 -78.6527)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-259.974, -171.3473)",
    d: "M 279 202.56 c -6.55 0.17 -12.6 -0.49 -16.51 -2.7 c -5.36 -3 -17.4 -35.59 -20.48 -47.08 c -2 -7.33 -1.2 -13.06 2.61 -12.65 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.4749 -93.5525)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-219.5252, -156.4476)",
    d: "M 239.51 138.92 c -5.62 -3 -21.08 -4.34 -27.3 -0.16 c -7.86 5.27 -15.1 35.82 -11.89 37.63 c 5.72 3.22 25.52 -14.53 29.84 -21.81 S 239.51 138.92 239.51 138.92 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.4724 -92.7437)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-219.5276, -157.2563)",
    d: "M 239.51 138.92 s -5 8.37 -9.35 15.66 s -24.12 25 -29.84 21.8 c -2.52 -1.42 1.44 -20.7 7.08 -31.39 l 29.16 -7.24 A 15.75 15.75 0 0 1 239.51 138.92 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.7219 -68.1226)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-232.2781, -181.8774)",
    d: "M 199.18 226.67 c 0.17 0.18 64.4 -0.6 65 -1.33 a 19.66 19.66 0 0 0 2.91 -14.12 c -4.29 -21.85 -15.68 -63.21 -19.91 -70.06 c -2.65 -4.28 -13.38 -5.75 -18 -1.78 c -8.63 7.35 -25.58 50.84 -31.32 73.46 C 195.81 220.81 199 226.51 199.18 226.67 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.15 -65.77)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-233.85, -184.23)",
    d: "M 264.84 224.31 a 1.76 1.76 0 0 1 -0.14 0.23 a 57.15 57.15 0 0 1 -5.48 -5.3 c -2.12 -2.3 -4.14 -4.7 -6.07 -7.16 c -3.88 -4.9 -7.53 -10 -11.57 -14.75 c -0.89 -1 -1.78 -2.06 -2.7 -3.07 l -0.33 -0.36 c -1.08 -1.17 -2.19 -2.31 -3.36 -3.4 a 48.52 48.52 0 0 0 -7.36 -5.74 a 32.52 32.52 0 0 0 -8.53 -3.71 c -0.76 -0.17 -1.5 -0.41 -2.27 -0.52 l -2.3 -0.34 c -0.77 -0.1 -1.55 -0.09 -2.33 -0.14 l -1.16 -0.05 l -1.17 0 c -0.5 0 -1 0 -1.51 0.05 c 0.05 -0.12 0.1 -0.25 0.14 -0.38 c 0.45 0 0.91 0 1.36 0 l 1.18 0 l 1.17 0.06 c 0.79 0.05 1.58 0 2.35 0.15 l 2.33 0.35 c 0.78 0.12 1.53 0.37 2.3 0.54 a 33.1 33.1 0 0 1 8.59 3.78 a 48.61 48.61 0 0 1 7.36 5.81 c 1.19 1.12 2.33 2.3 3.43 3.51 l 0.33 0.37 c 0.89 1 1.76 2 2.62 3 c 4 4.8 7.68 9.86 11.58 14.74 c 1.94 2.45 4 4.84 6.08 7.13 A 58.49 58.49 0 0 0 264.84 224.31 Z m -0.92 -27.58 a 30.06 30.06 0 0 0 -3 -1.49 a 31.85 31.85 0 0 0 -8.41 -2.33 l -0.26 0 l -0.4 -0.05 a 42.81 42.81 0 0 0 -9.4 0.26 a 35.13 35.13 0 0 0 -3.67 0.76 a 1.8 1.8 0 0 0 -0.22 0.06 a 36 36 0 0 0 -5.15 1.78 a 39.69 39.69 0 0 0 -8.12 4.73 a 59.66 59.66 0 0 0 -7 6.27 c -4.37 4.5 -8.17 9.49 -12.26 14.2 a 65.75 65.75 0 0 1 -5.62 5.82 h 0.69 a 65.3 65.3 0 0 0 5.28 -5.51 c 4.1 -4.74 7.89 -9.72 12.23 -14.2 a 61.14 61.14 0 0 1 6.95 -6.22 a 39.66 39.66 0 0 1 8 -4.69 a 35.65 35.65 0 0 1 5.3 -1.82 l 0.22 0 c 1.13 -0.29 2.26 -0.53 3.4 -0.72 a 42.55 42.55 0 0 1 9.3 -0.3 l 0.77 0.1 l 0.27 0 a 32 32 0 0 1 8 2.21 a 27.7 27.7 0 0 1 3.23 1.6 C 264 197 264 196.87 263.92 196.73 Z m 3.19 14.49 a 0.5 0.5 0 0 1 0 -0.12 c -0.9 -1 -1.76 -2 -2.62 -3 c -4 -4.76 -7.7 -9.84 -11.58 -14.74 l 0 -0.07 c -0.11 -0.14 -0.22 -0.28 -0.34 -0.41 c -1.8 -2.29 -3.69 -4.53 -5.67 -6.68 a 56.14 56.14 0 0 0 -6.85 -6.41 a 35.52 35.52 0 0 0 -8 -4.89 a 32.1 32.1 0 0 0 -9.08 -2.42 a 42.85 42.85 0 0 0 -9.4 0.26 c -0.75 0.12 -1.49 0.25 -2.23 0.41 c -0.06 0.17 -0.13 0.33 -0.2 0.5 c 0.83 -0.2 1.66 -0.36 2.5 -0.5 a 42.53 42.53 0 0 1 9.3 -0.3 a 31.73 31.73 0 0 1 9 2.34 a 35.5 35.5 0 0 1 8 4.8 a 56.53 56.53 0 0 1 6.85 6.36 c 2 2.09 3.8 4.26 5.58 6.49 l 0.33 0.42 l 0.17 0.21 c 3.9 4.89 7.58 9.94 11.59 14.75 c 0.93 1.09 1.86 2.18 2.83 3.24 C 267.14 211.4 267.13 211.31 267.11 211.22 Z m -16.64 -62.29 A 38.45 38.45 0 0 1 243 153.2 a 36.67 36.67 0 0 1 -5.29 1.81 l -0.23 0.06 c -1.13 0.29 -2.26 0.52 -3.4 0.71 a 42.57 42.57 0 0 1 -9.3 0.31 a 31.48 31.48 0 0 1 -5.53 -1.1 l -0.15 0.31 a 32.83 32.83 0 0 0 5.64 1.16 a 42.85 42.85 0 0 0 9.4 -0.26 c 1.23 -0.2 2.46 -0.45 3.67 -0.77 a 0.9 0.9 0 0 0 0.22 -0.06 a 36 36 0 0 0 5.15 -1.77 a 39.48 39.48 0 0 0 7.42 -4.23 C 250.57 149.22 250.52 149.07 250.47 148.93 Z m 5.93 19 a 32.46 32.46 0 0 1 -7.62 -3.44 a 48.52 48.52 0 0 1 -7.36 -5.74 c -1.17 -1.09 -2.28 -2.23 -3.36 -3.41 l -0.32 -0.36 c -0.93 -1 -1.82 -2 -2.71 -3.07 s -1.58 -1.89 -2.35 -2.85 l -0.32 -0.39 c -1.82 -2.29 -3.6 -4.62 -5.38 -6.95 a 1.71 1.71 0 0 0 -0.11 0.14 c 1.75 2.26 3.49 4.53 5.27 6.77 l 0.31 0.39 c 0.8 1 1.61 2 2.44 3 s 1.73 2 2.62 3 q 0.15 0.18 0.33 0.36 c 1.09 1.21 2.23 2.39 3.42 3.51 a 49.26 49.26 0 0 0 7.37 5.82 a 32.39 32.39 0 0 0 7.87 3.55 A 3.57 3.57 0 0 1 256.4 168 Z m -6.57 -20.81 a 46.44 46.44 0 0 1 -12.24 1.78 l -1.16 0 l -1.17 -0.05 c -0.77 0 -1.55 0 -2.32 -0.14 l -0.58 -0.08 l -0.22 0 l -1.51 -0.22 c -0.77 -0.12 -1.51 -0.36 -2.27 -0.53 a 31.07 31.07 0 0 1 -4.46 -1.57 l -0.14 0.26 a 32.41 32.41 0 0 0 4.52 1.62 c 0.76 0.18 1.51 0.42 2.29 0.55 l 1.88 0.28 l 0.23 0 l 0.22 0 c 0.78 0.1 1.57 0.1 2.35 0.15 l 1.18 0.06 l 1.17 0 a 48 48 0 0 0 9.34 -1 c 1 -0.21 2 -0.46 3 -0.75 A 3.25 3.25 0 0 1 249.83 147.15 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -55.655 39.17)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(166,166,166)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "33.875,36.68 -33.875,31.58 -18.785,-36.68 29.195,-33.06 33.875,36.68 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.485 40.98)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(199,199,199)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "4.025,-34.87 -8.705,33.56 8.705,34.87 4.025,-34.87 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -51.3492 -2.6721)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-198.6508, -247.3279)",
    d: "M 187.69 258.46 l -2.39 -0.61 c 0 -0.06 1.67 -6.6 3.42 -13.2 c 1.89 -7.13 9.09 -10.17 15 -9 c 4.39 0.89 9.17 4.53 8.14 11.88 c -1.09 7.87 -1.83 11.56 -1.86 11.72 l -2.42 -0.49 s 0.76 -3.79 1.84 -11.57 c 0.79 -5.65 -2.68 -8.42 -6.19 -9.12 c -4.75 -1 -10.58 1.47 -12.1 7.2 C 189.35 251.87 187.71 258.39 187.69 258.46 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.35 72.235)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-219.65, -322.235)",
    d: "M 211.77 324.08 c 1.46 -0.88 3 -1.68 4.48 -2.48 s 3.05 -1.55 4.59 -2.28 l 0.21 -0.1 l 0.18 0.15 c 1.08 0.95 2.16 1.89 3.2 2.88 s 2.1 2 3.1 3 c -1.18 -0.83 -2.32 -1.71 -3.44 -2.61 s -2.23 -1.81 -3.33 -2.74 l 0.39 0 q -2.29 1.13 -4.64 2.17 C 214.94 322.81 213.38 323.49 211.77 324.08 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -27.91 43.145)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-222.09, -293.145)",
    d: "M 221 319.64 c 0 -4.42 0.14 -8.84 0.27 -13.26 s 0.31 -8.83 0.46 -13.25 s 0.39 -8.83 0.63 -13.24 l 0.37 -6.63 c 0.15 -2.2 0.28 -4.41 0.45 -6.61 c 0 2.21 -0.06 4.42 -0.1 6.63 l -0.17 6.63 c -0.12 4.42 -0.31 8.83 -0.46 13.25 s -0.39 8.83 -0.63 13.25 S 221.33 315.23 221 319.64 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -63.4979 8.1578)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-186.5021, -258.1579)",
    d: "M 189.77 258.28 a 3.27 3.27 0 1 1 -3.15 -3.39 A 3.28 3.28 0 0 1 189.77 258.28 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -41.4874 8.9979)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-208.5126, -258.9979)",
    d: "M 211.78 259.13 a 3.27 3.27 0 1 1 -3.15 -3.4 A 3.27 3.27 0 0 1 211.78 259.13 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -67.895 46.25)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "33.565,47.06 -42.425,27.49 -11.405,-47.06 42.425,-33.2 33.565,47.06 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -39.66 53.18)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "14.19,-40.13 -14.19,35.1 5.33,40.13 14.19,-40.13 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -39.66 53.18)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    points: "14.19,-40.13 -14.19,35.1 5.33,40.13 14.19,-40.13 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -53.0395 1.0573)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-196.9605, -251.0574)",
    d: "M 184.48 258.42 l -2.24 -1.11 c 0 -0.06 3.08 -6.21 6.24 -12.4 c 3.42 -6.68 11.24 -8.15 16.83 -5.71 c 4.18 1.83 8.14 6.48 5.54 13.57 c -2.79 7.59 -4.32 11.11 -4.39 11.25 l -2.29 -1 s 1.57 -3.61 4.33 -11.11 c 2 -5.45 -0.86 -8.95 -4.2 -10.41 c -4.52 -2 -10.84 -0.81 -13.59 4.56 C 187.56 252.23 184.51 258.36 184.48 258.42 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -43.83 88.455)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-206.17, -338.455)",
    d: "M 197.33 338 c 1.85 -0.71 3.73 -1.31 5.6 -1.91 s 3.78 -1.14 5.68 -1.65 l 0.27 -0.08 l 0.16 0.21 c 1 1.3 2.08 2.59 3.06 3.93 s 2 2.66 2.91 4.05 c -1.17 -1.19 -2.28 -2.42 -3.38 -3.67 s -2.17 -2.51 -3.22 -3.79 l 0.42 0.14 c -1.89 0.54 -3.8 1 -5.71 1.51 S 199.28 337.6 197.33 338 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -34.655 54.87)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-215.345, -304.87)",
    d: "M 208.72 334.78 c 0.94 -5 2 -10 3 -15 s 2.14 -10 3.21 -15 s 2.24 -10 3.41 -14.93 l 1.77 -7.45 c 0.62 -2.48 1.21 -5 1.86 -7.44 c -0.46 2.52 -1 5 -1.46 7.52 L 219 290 c -1 5 -2.15 10 -3.22 15 s -2.24 10 -3.41 14.94 S 210 329.83 208.72 334.78 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -66.6427 7.864)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-183.3573, -257.864)",
    d: "M 186.58 258.7 a 3.33 3.33 0 1 1 -2.39 -4.06 A 3.32 3.32 0 0 1 186.58 258.7 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -44.9327 13.454)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-205.0673, -263.454)",
    d: "M 208.29 264.29 a 3.33 3.33 0 1 1 -2.39 -4.06 A 3.32 3.32 0 0 1 208.29 264.29 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -44.1179 -69.759)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-205.882, -180.241)",
    d: "M 221.67 141.89 c -7.38 3 -37.54 19.54 -41 25 c -6.35 9.86 -4.15 44.4 -3.16 52.21 c 0.43 3.4 28.48 1.51 28.28 -2.15 c -0.14 -2.47 -5.4 -33.95 -4.6 -36.57 s 18.34 -20.31 28.41 -28.82 C 239.15 143.45 237.31 135.59 221.67 141.89 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -53.9932 -18.8658)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-196.0068, -231.1342)",
    d: "M 211.66 247.37 a 4.2 4.2 0 0 1 -4.79 -0.17 a 6.21 6.21 0 0 1 -2.89 3.09 c -2.34 1.06 -5 -2.14 -5 -2.14 a 7.63 7.63 0 0 1 -3.57 2.79 c -2.34 0.79 -5.51 -2.06 -5.51 -2.06 a 6.74 6.74 0 0 1 -4.68 0.47 c -4.13 -1.26 -5.84 -7.64 -7 -11.69 s -0.54 -16.57 -0.67 -19 l 25.9 -7.47 s 10.22 16.7 10.87 21.64 C 214.87 237 214.34 245.49 211.66 247.37 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -43.3122 -9.862)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-206.6878, -240.138)",
    d: "M 207.23 246.9 c 0.48 -4.57 -0.42 -9 -1.06 -13.54 a 0.08 0.08 0 0 0 -0.16 0 c 0.69 4.47 0.49 9 1 13.51 A 0.11 0.11 0 0 0 207.23 246.9 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -52.1708 -8.4048)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-197.8293, -241.5952)",
    d: "M 199.27 248 a 12.09 12.09 0 0 0 -0.39 -3.1 c -0.21 -1.09 -0.44 -2.18 -0.69 -3.26 q -0.74 -3.26 -1.64 -6.46 c 0 -0.09 -0.18 -0.08 -0.16 0 c 0.49 2.16 1 4.33 1.35 6.51 q 0.3 1.63 0.57 3.27 A 13.89 13.89 0 0 0 199 248 A 0.16 0.16 0 0 0 199.27 248 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -61.5008 -7.0438)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-188.4992, -242.9561)",
    d: "M 189.86 248.79 a 8.36 8.36 0 0 0 -0.5 -2.78 c -0.25 -1 -0.49 -2 -0.72 -2.95 c -0.47 -2 -0.94 -3.94 -1.34 -5.92 c 0 -0.1 -0.18 -0.08 -0.16 0 c 0.4 2 0.77 4 1.18 6.06 l 0.63 3 a 8 8 0 0 0 0.81 2.64 S 189.85 248.84 189.86 248.79 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -44.5768 -71.3011)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-205.4231, -178.699)",
    d: "M 205.57 211.15 l -30.21 7.15 s -3 -38.23 4.27 -52.55 c 3 -5.9 30.54 -21.32 42.73 -25.18 s 20.49 -0.3 6.23 12.71 s -26.5 25.07 -26.42 26.38 S 205.57 211.15 205.57 211.15 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.2415 -83.1271)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-214.7585, -166.8729)",
    d: "M 205.94 175.6 c 1 -0.78 6.06 -6.07 7.8 -7.78 c 1.42 -1.4 2.87 -2.77 4.32 -4.13 c 1 -0.71 2 -1.4 3 -2.13 a 0.07 0.07 0 0 0 -0.08 -0.11 l -2.09 1.46 c 1.86 -1.73 3.73 -3.47 5.56 -5.23 c 0.05 -0.05 0 -0.11 -0.07 -0.07 c -3.17 2.56 -6.25 5.2 -9.26 8 a 122.2 122.2 0 0 0 -9.72 10 C 204.73 176.35 205.07 176.31 205.94 175.6 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -60.116 -41.215)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-189.884, -208.785)",
    d: "M 202.68 206 c -2.1 0.17 -4.21 0.66 -6.28 1 s -4.31 0.87 -6.46 1.33 s -10.67 2.57 -12.8 3.1 a 0.07 0.07 0 1 0 0 0.14 c 2.17 -0.39 10.73 -2 12.84 -2.42 s 4.21 -0.9 6.31 -1.41 a 64.25 64.25 0 0 0 6.37 -1.69 S 202.73 206 202.68 206 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -45.335 -47.41)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-204.665, -202.59)",
    d: "M 203.68 193.85 c 0.59 2.86 1 5.73 1.32 8.61 c 0.16 1.44 0.29 2.89 0.41 4.33 s 0.2 2.9 0.24 4.35 v 0.08 h -0.06 l -0.83 0.11 l 0.79 -0.26 l -0.05 0.08 c -0.29 -1.43 -0.49 -2.87 -0.72 -4.3 s -0.37 -2.88 -0.52 -4.32 C 204 199.66 203.72 196.77 203.68 193.85 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -12.037 -112.8577)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-237.9631, -137.1423)",
    d: "M 242.72 149 c -3.5 0.85 -10.32 -4.89 -12.73 -9.22 c -0.16 -0.29 0.28 -3.43 0.62 -7.27 c 0.2 -2.33 0.37 -4.93 0.36 -7.31 l 15 3.53 a 37.63 37.63 0 0 0 -1.38 9.16 a 5 5 0 0 0 0.1 1 s 0 0.1 0 0.17 C 245 140.85 246.1 148.15 242.72 149 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11.06 -117.7492)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.94, -132.2508)",
    d: "M 244.66 138.84 a 0.61 0.61 0 0 1 0 0.15 a 9.07 9.07 0 0 1 -1.53 0.1 c -8.65 -0.13 -10.76 -10.7 -11.17 -13.68 l 3.74 0.88 l 10.22 2.41 a 37.73 37.73 0 0 0 -1.38 9.16 A 5.17 5.17 0 0 0 244.66 138.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.2676 -132.4664)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-242.7324, -117.5336)",
    d: "M 230 107.84 c -1.61 5.42 1.37 21 5.24 24.49 c 5.62 5 14.75 5.42 19 -1.31 c 4.11 -6.54 -0.13 -26.81 -4.45 -29.94 C 243.47 96.46 232.42 99.83 230 107.84 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.7203 -130.9895)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-245.2797, -119.0105)",
    d: "M 245.46 117.52 s -0.07 0.07 -0.06 0.11 c 0.22 1.05 0.31 2.28 -0.58 2.81 c 0 0 0 0.07 0 0.06 C 246 120.12 245.84 118.48 245.46 117.52 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.5476 -131.6846)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-244.4524, -118.3153)",
    d: "M 244.32 116.6 c -1.72 0.18 -1.22 3.6 0.37 3.43 S 245.75 116.44 244.32 116.6 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.098 -132.12)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-252.0979, -117.88)",
    d: "M 251.33 116.57 s 0.09 0 0.1 0.08 c 0.12 1.07 0.44 2.27 1.44 2.48 c 0 0 0 0.06 0 0.06 C 251.68 119.19 251.28 117.6 251.33 116.57 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.5445 -132.9859)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-252.5445, -117.0141)",
    d: "M 252.12 115.33 c 1.68 -0.38 2.31 3 0.75 3.37 S 250.71 115.64 252.12 115.33 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.5633 -136.0636)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.4367, -113.9364)",
    d: "M 242.74 115.23 a 12.6 12.6 0 0 0 1.26 -0.66 a 2.31 2.31 0 0 0 1.15 -0.91 a 0.75 0.75 0 0 0 -0.24 -0.86 a 1.82 1.82 0 0 0 -1.84 0.08 a 2.64 2.64 0 0 0 -1.35 1.36 A 0.78 0.78 0 0 0 242.74 115.23 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.0755 -137.6369)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-252.0755, -112.3631)",
    d: "M 253.19 113.42 a 13.22 13.22 0 0 1 -1.41 -0.16 a 2.33 2.33 0 0 1 -1.41 -0.43 a 0.72 0.72 0 0 1 -0.08 -0.89 a 1.82 1.82 0 0 1 1.73 -0.6 a 2.67 2.67 0 0 1 1.76 0.78 A 0.78 0.78 0 0 1 253.19 113.42 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.3705 -122.2806)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-246.6296, -127.7194)",
    d: "M 245.61 127.31 c 0.29 0.21 0.59 0.52 1 0.49 a 2.81 2.81 0 0 0 1.1 -0.43 a 0 0 0 0 1 0.05 0 a 1.43 1.43 0 0 1 -1.26 0.77 a 1.13 1.13 0 0 1 -1 -0.82 C 245.49 127.32 245.57 127.28 245.61 127.31 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.7024 -131.4147)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-249.2976, -118.5852)",
    d: "M 246.26 124 a 3.63 3.63 0 0 0 2.64 1.25 a 4.17 4.17 0 0 0 1.31 -0.13 a 0.94 0.94 0 0 0 0.24 -0.06 l 0.23 -0.07 a 0.28 0.28 0 0 0 0.18 -0.27 h 0 a 0.44 0.44 0 0 0 0 -0.1 h 0 l 0 -0.09 c -0.09 -0.82 -0.35 -2 -0.35 -2 c 0.32 0.11 1.93 0.57 1.85 0.15 a 54.29 54.29 0 0 0 -3 -10.71 a 0.1 0.1 0 0 0 -0.19 0.05 c 0.57 3.39 1.72 6.65 2.34 10 a 6.16 6.16 0 0 0 -1.78 -0.27 c -0.11 0.05 0.54 2.36 0.56 2.74 v 0 a 5 5 0 0 1 -3.9 -0.62 C 246.26 123.82 246.19 123.9 246.26 124 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.0793 -124.6753)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-247.9206, -125.3247)",
    d: "M 249.72 125 a 4.22 4.22 0 0 1 -1.59 1.44 a 1.84 1.84 0 0 1 -1.14 0.16 c -0.86 -0.15 -0.94 -0.92 -0.83 -1.58 a 4.52 4.52 0 0 1 0.29 -1 A 5.52 5.52 0 0 0 249.72 125 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.8743 -124.1658)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,152,185)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-247.1256, -125.8343)",
    d: "M 248.13 126.45 a 1.84 1.84 0 0 1 -1.14 0.16 c -0.86 -0.15 -0.94 -0.92 -0.83 -1.58 A 2 2 0 0 1 248.13 126.45 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -10.4664 -140.9067)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-239.5336, -109.0933)",
    d: "M 230.32 122.13 c -0.5 -1.39 -5.23 -16.49 -4.94 -18.19 c 0.26 -1.55 2 -1 2 -1.13 s 0 -1.48 0.8 -2.06 a 2.34 2.34 0 0 1 1.86 -0.1 s 0.16 -1.48 1.06 -1.94 a 1.85 1.85 0 0 1 1.82 0.27 a 2.47 2.47 0 0 1 1.35 -1.85 a 1.6 1.6 0 0 1 1.83 0.55 s 0.29 -1.42 1.23 -1.76 s 1.85 0.64 1.85 0.64 s 0.44 -1.31 1.6 -1.4 a 1.85 1.85 0 0 1 1.71 1.14 s 0.6 -1.28 1.7 -1.38 s 1.57 1.23 1.57 1.23 s 0.36 -1.25 1.4 -1.24 s 1.38 1.43 1.38 1.43 s 0.48 -1.38 1.72 -1.07 c 1.91 0.48 2.75 9.36 3.44 13.2 c 0 0 -0.64 -1.81 -1.44 -1.83 s -1.3 1.29 -2.75 1.72 c -2.07 0.61 -5.73 -1.62 -8.58 -0.8 s -4.65 3.9 -5.36 8.38 C 234.76 121 231.5 125.45 230.32 122.13 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.3146 -131.2673)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.6854, -118.7327)",
    d: "M 248.14 117.38 a 4.65 4.65 0 1 0 -4.28 6 a 4.12 4.12 0 0 0 1.14 -0.19 a 4.65 4.65 0 0 0 3.14 -5.77 Z m -3.31 5.18 a 4 4 0 1 1 -2.28 -7.72 a 3.79 3.79 0 0 1 1 -0.16 a 4 4 0 0 1 1.29 7.88 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.1915 -131.3074)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-243.8086, -118.6927)",
    d: "M 244.83 122.56 a 4 4 0 1 1 -2.28 -7.72 a 3.79 3.79 0 0 1 1 -0.16 a 4 4 0 0 1 1.29 7.88 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.957 -132.9748)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-253.957, -117.0253)",
    d: "M 257.39 116.49 a 5.51 5.51 0 0 0 -1.47 -3.06 a 3 3 0 0 0 -2.66 -1 A 3.08 3.08 0 0 0 251 114.2 a 5.53 5.53 0 0 0 -0.47 3.36 c 0.37 2.39 2.05 4.15 3.83 4.08 a 1.53 1.53 0 0 0 0.3 0 C 256.58 121.32 257.79 119 257.39 116.49 Z M 254.6 121 c -1.55 0.24 -3.09 -1.35 -3.43 -3.54 a 4.92 4.92 0 0 1 0.41 -3 a 2.48 2.48 0 0 1 1.78 -1.43 a 1.6 1.6 0 0 1 0.23 0 a 2.55 2.55 0 0 1 1.89 0.85 a 4.94 4.94 0 0 1 1.3 2.72 C 257.12 118.78 256.14 120.76 254.6 121 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.9703 -132.975)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-253.9703, -117.0249)",
    d: "M 254.6 121 c -1.55 0.24 -3.09 -1.35 -3.43 -3.54 a 4.92 4.92 0 0 1 0.41 -3 a 2.48 2.48 0 0 1 1.78 -1.43 a 1.6 1.6 0 0 1 0.23 0 a 2.55 2.55 0 0 1 1.89 0.85 a 4.94 4.94 0 0 1 1.3 2.72 C 257.12 118.78 256.14 120.76 254.6 121 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.7 -132.8318)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-249.3, -117.1683)",
    d: "M 248.07 117.94 l -0.47 -0.41 c 0.61 -0.69 2.09 -1.73 3.4 -0.7 l -0.38 0.48 C 249.45 116.39 248.12 117.88 248.07 117.94 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.655 -129.825)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,59,99)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-233.345, -120.175)",
    d: "M 227.8 122.31 l -0.59 -0.19 c 0.09 -0.28 0.94 -2.7 2.27 -3.14 s 9.6 -0.91 10 -0.94 l 0 0.62 c -2.39 0.15 -8.83 0.6 -9.8 0.91 S 228 121.65 227.8 122.31 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.8665 -128.3419)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(235,148,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-231.1334, -121.6581)",
    d: "M 234 120.55 s -3.68 -5 -5.93 -3.63 s 0.6 8.58 3.32 9.5 a 2.73 2.73 0 0 0 3.62 -1.57 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.7949 -127.9265)",
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-231.2051, -122.0735)",
    d: "M 228.9 119 a 0 0 0 0 0 0 0.07 c 1.9 0.71 3 2.44 3.69 4.23 a 1.51 1.51 0 0 0 -2.27 -0.35 c -0.05 0 0 0.11 0.05 0.1 a 1.67 1.67 0 0 1 1.87 0.54 a 8.29 8.29 0 0 1 0.93 1.47 c 0.09 0.17 0.4 0.07 0.33 -0.12 l 0 0 C 233.45 122.47 231.49 119.15 228.9 119 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepage);
export default __webpack_public_path__ + "static/media/homepage.1f09df72f40ea13739c8e459906ff13b.svg";
export { ForwardRef as ReactComponent };